
// // UserGroupDetails.jsx
// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "./DropdownPrevValue";
// import SingleSelectSearchDropdown from "../../StudentGrouph/SingleSelectSearchDropdown";
// import TableForAccessView from "../../../Components/TableComponent/TableForAccessView";
// import SuccessImg from ".././../../Assets/Images/CommanImages/Informative.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import { API_BASE_URL } from "../../../Config/Config";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { fetchSessionData } from "../../../Redux/Sessions/sessionSlice";
// import "./updatedusergroup.css";

// function UserGroupDetails({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();

//   const passedHeaders = location.state?.headers ?? [];
//   const passedRow = location.state?.rowData ?? [];
//   const query = new URLSearchParams(location.search || "");

//   const headerIndexOf = (name) => {
//     if (!Array.isArray(passedHeaders)) return -1;
//     const exact = passedHeaders.findIndex((h) => String(h).trim() === name);
//     if (exact !== -1) return exact;
//     const strippedIndex = passedHeaders.findIndex(
//       (h) =>
//         String(h)
//           .replace(/^[a-z]\*/, "")
//           .trim() === name
//     );
//     if (strippedIndex !== -1) return strippedIndex;
//     const ci = passedHeaders.findIndex(
//       (h) =>
//         String(h)
//           .replace(/^[a-z]\*/, "")
//           .trim()
//           .toLowerCase() === name.toLowerCase()
//     );
//     return ci;
//   };

//   const getValueFromPassed = (name) => {
//     if (!Array.isArray(passedRow) || passedRow.length === 0) return "";
//     const idx = headerIndexOf(name);
//     if (idx === -1) return "";
//     const v = passedRow[idx];
//     return v === null || v === undefined ? "" : v;
//   };

//   const findValue = (names) => {
//     for (const n of names) {
//       const v = getValueFromPassed(n);
//       if (v !== "") return v;
//       const q = query.get(n) ?? query.get(n.replace(/\s+/g, ""));
//       if (q) return q;
//     }
//     return "";
//   };

//   // --- initial states (read once or via effect below) ---
//   const [userGroupId] = useState(() =>
//     findValue(["User Group ID", "UserGroupId", "UserGroupID"])
//   );
//   const [studentGroupName, setStudentGroupName] = useState(() =>
//     findValue(["User Group Name", "UserGroupName", "t*User Group Name"])
//   );
//   const [studentGroupDesc, setStudentGroupDesc] = useState(() =>
//     findValue([
//       "User Group Description",
//       "UserGroupDescription",
//       "t*User Group Description",
//     ])
//   );

//   // compute initial flags === this will be overwritten by useEffect below (matching your working code)
//   const initialMessageFlag = (() => {
//     const v = findValue(["Message Flag", "MessageFlag", "t*Message Flag"]);
//     if (v === "" || v === null) return 0;
//     return Number(v) === 1 ? 1 : 0;
//   })();
//   const initialEmailFlag = (() => {
//     const v = findValue(["Email Flag", "EmailFlag", "t*Email Flag"]);
//     if (v === "" || v === null) return 0;
//     return Number(v) === 1 ? 1 : 0;
//   })();

//   const [messageFlag, setMessageFlag] = useState(initialMessageFlag); // 1 or 0
//   const [emailFlag, setEmailFlag] = useState(initialEmailFlag); // 1 or 0

//   const [comments, setComments] = useState(() =>
//     findValue(["Comments", "t*Comments"])
//   );
//   const [status, setStatus] = useState(() => {
//     const v = findValue(["Status", "t*Status"]);
//     if (String(v) === "0") return "Inactive";
//     return v || "";
//   });
//   const [lastModifiedDate, setLastModifiedDate] = useState(() =>
//     findValue([
//       "Last Modified Date",
//       "LastModifiedDate",
//       "d*Last Modified Date",
//     ])
//   );
//   const [createdBy, setCreatedBy] = useState(() =>
//     findValue(["Created By", "CreatedBy", "t*Created By"])
//   );
//   const [groupOwnerName, setGroupOwnerName] = useState(() =>
//     findValue(["Group Owner Name", "GroupOwnerName", "t*Group Owner Name"])
//   );
//   const [defaultUserGroup, setDefaultUserGroup] = useState(() =>
//     findValue(["Default Group", "DefaultUserGroup", "t*Default Group"])
//   );

//   // reviewer group fields
//   const [quesReviewerGroupId, setQuesReviewerGroupId] = useState(() =>
//     findValue([
//       "Ques Reviewer Group ID",
//       "QuesReviewerGroupID",
//       "n*Ques Reviewer Group ID",
//     ])
//   );
//   const [courseIdField, setCourseIdField] = useState(() =>
//     findValue(["Course ID", "CourseID", "n*Course ID"])
//   );
//   const [courseNameField, setCourseNameField] = useState(() =>
//     findValue(["Course Name", "CourseName", "t*Course Name"])
//   );
//   const [subjectIdField, setSubjectIdField] = useState(() =>
//     findValue(["Subject ID", "SubjectID", "n*Subject ID"])
//   );
//   const [subjectNameField, setSubjectNameField] = useState(() =>
//     findValue(["Subject Name", "SubjectName", "t*Subject Name"])
//   );
//   const [reviewerGroupType, setReviewerGroupType] = useState(() =>
//     findValue([
//       "Reviewer Group Type",
//       "ReviewerGroupType",
//       "t*Reviewer Group Type",
//     ])
//   );
//   const [facultyReviewLevel, setFacultyReviewLevel] = useState(() =>
//     findValue([
//       "Faculty Review Level",
//       "FacultyReviewLevel",
//       "n*Faculty Review Level",
//     ])
//   );

//   // access table
//   const [groupedRows, setGroupedRows] = useState([]);
//   const [selectedUserGroups, setSelectedUserGroups] = useState([]);
//   const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);

//   // fetch courses/sessions
//   useEffect(() => {
//     dispatch(fetchCourseData());
//     dispatch(fetchSessionData());
//   }, [dispatch]);

//   // IMPORTANT: this effect mirrors your working code exactly — it sets messageFlag & emailFlag
//   // from incoming row/query values so they remain present when user clicks EDIT.
//   useEffect(() => {
//     setStudentGroupName(
//       findValue(["User Group Name", "UserGroupName", "t*User Group Name"])
//     );
//     setStudentGroupDesc(
//       findValue([
//         "User Group Description",
//         "UserGroupDescription",
//         "t*User Group Description",
//       ])
//     );

//     // *** Keep these lines (as in your working example) so flags are set from incoming props/state ***
//     setMessageFlag(
//       (() => {
//         const v = findValue(["Message Flag", "MessageFlag", "t*Message Flag"]);
//         // console.log("Setting messageFlag from value:", v);
//         // return v === "" || v === null ? 0 : Number(v) === 1 ? 1 : 0;
//         return v == "True" ? "True" : "False";

//       })()
//     );
//     setEmailFlag(
//       (() => {
//         const v = findValue(["Email Flag", "EmailFlag", "t*Email Flag"]);
//         // console.log("Setting emailFlag from value:", v);
//         // return v === "" || v === null ? 0 : Number(v) === 1 ? 1 : 0;
//         return v == "True" ? "True" : "False";
//       })()
//     );

//     setComments(findValue(["Comments", "t*Comments"]));
//     setStatus(
//       (() => {
//         const v = findValue(["Status", "t*Status"]);
//         return String(v) === "0" ? "Inactive" : v || "";
//       })()
//     );
//     setLastModifiedDate(
//       findValue([
//         "Last Modified Date",
//         "LastModifiedDate",
//         "d*Last Modified Date",
//       ])
//     );
//     setCreatedBy(findValue(["Created By", "CreatedBy", "t*Created By"]));
//     setGroupOwnerName(
//       findValue(["Group Owner Name", "GroupOwnerName", "t*Group Owner Name"])
//     );
//     setDefaultUserGroup(
//       findValue(["Default Group", "DefaultUserGroup", "t*Default Group"])
//     );
//     setQuesReviewerGroupId(
//       findValue([
//         "Ques Reviewer Group ID",
//         "QuesReviewerGroupID",
//         "n*Ques Reviewer Group ID",
//       ])
//     );
//     setCourseIdField(findValue(["Course ID", "CourseID", "n*Course ID"]));
//     setCourseNameField(
//       findValue(["Course Name", "CourseName", "t*Course Name"])
//     );
//     setSubjectIdField(findValue(["Subject ID", "SubjectID", "n*Subject ID"]));
//     setSubjectNameField(
//       findValue(["Subject Name", "SubjectName", "t*Subject Name"])
//     );
//     setReviewerGroupType(
//       findValue([
//         "Reviewer Group Type",
//         "ReviewerGroupType",
//         "t*Reviewer Group Type",
//       ])
//     );
//     setFacultyReviewLevel(
//       findValue([
//         "Faculty Review Level",
//         "FacultyReviewLevel",
//         "n*Faculty Review Level",
//       ])
//     );
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [location.state]);

//   const showMessage = (text, success = true) => {
//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{text}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(success ? SuccessImg : ErrorImg);
//       setIsMessageBoxVisible(true);
//       setTimeout(() => setIsMessageBoxVisible(false), 2500);
//     } else {
//       console.log("MSG:", text);
//     }
//   };

//   const isInactive = () => {
//     const s = String(status || "").toLowerCase();
//     return s === "inactive" || s === "0";
//   };

//   // fetch roles/screens/reports for this user group from API
//   useEffect(() => {
//     async function fetchRolesForGroup() {
//       if (!userGroupId) {
//         setGroupedRows([]);
//         return;
//       }

//       try {
//         const token = localStorage.getItem("other");
//         const qs = new URLSearchParams({ user_group_id: String(userGroupId) });
//         const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-user-group-role-screen-report-access-details-by-user-id?${qs.toString()}`;

//         const res = await fetch(url, {
//           method: "GET",
//           headers: {
//             Accept: "application/json",
//             ...(token ? { Authorization: `Bearer ${token}` } : {}),
//           },
//         });

//         const json = await res.json();

//         if (
//           res.ok &&
//           json &&
//           json.status === 200 &&
//           Array.isArray(json.data) &&
//           json.data.length > 0
//         ) {
//           setGroupedRows(json.data);
//         } else {
//           setGroupedRows([]);
//           // if (json && json.message) showMessage(json.message, false);
//         }
//       } catch (err) {
//         console.error("Failed to fetch roles for group:", err);
//         setGroupedRows([]);
//         showMessage("Error fetching roles for user group", false);
//       }
//     }

//     fetchRolesForGroup();
//   }, [userGroupId]);

//   // Deactivate flow
//   const onDeactivateClicked = () => {
//     if (isInactive()) return;

//     if (!setMessageBox) {
//       if (
//         window.confirm("Are you sure you want to deactivate this user group?")
//       ) {
//         handleDeactivateConfirmed();
//       }
//       return;
//     }

//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Are you sure you want to deactivate this user group?</span>
//         </div>
//         <div
//           className="messagebox-insider2"
//           style={{
//             display: "flex",
//             gap: "10px",
//             marginTop: "10px",
//             justifyContent: "flex-end",
//           }}
//         >
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={async () => {
//               setIsMessageBoxVisible(false);
//               await handleDeactivateConfirmed();
//             }}
//           >
//             YES
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//             }}
//           >
//             NO
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//     setIsMessageBoxVisible(true);
//   };

//   const handleDeactivateConfirmed = async () => {
//     if (!userGroupId) {
//       showMessage("Missing user_group_id", false);
//       return;
//     }

//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Deactivating user group...</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       setIsMessageBoxVisible(true);
//     }

//     try {
//       const userNameForApi =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name ??
//         localStorage.getItem("username") ??
//         "";
//       const token = localStorage.getItem("other");
//       if (!token) {
//         showMessage("Not authenticated (missing token)", false);
//         return;
//       }

//       const qs = new URLSearchParams({
//         user_group_id: String(userGroupId),
//         comments: comments ?? "",
//         status: "0",
//         modified_by: userNameForApi ?? "",
//       });

//       const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/deactivate-user-group?${qs.toString()}`;
//       const resp = await fetch(url, {
//         method: "PUT",
//         headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       const json = await resp.json();

//       if (json && json.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {json.message || "User group deactivated successfully!"}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setStatus("Inactive");
//         setTimeout(() => setIsMessageBoxVisible(false), 2000);
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {(json && json.message) || "Failed to deactivate user group."}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Deactivate error:", err);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Error while deactivating user group.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   // --- edit state + group-owner selection logic ---
//   const [editMode, setEditMode] = useState(false);

//   // employee search options used by the owner selection dropdown
//   const [employeeOptions, setEmployeeOptions] = useState([]);
//   // selectedOwnerUserId stores the employee's user_id (as required by update API)
//   // try to read an initial user_id from passed props if present
//   const [selectedOwnerUserId, setSelectedOwnerUserId] = useState(() => {
//     const v = findValue([
//       "Group Owner User ID",
//       "GroupOwnerUserID",
//       "group_owner_user_id",
//     ]);
//     return v || "";
//   });

//   // fetch employees for group owner search (maps to user_id)
//   const fetchEmployeeCoordinator = (searchKey) => {
//     if (!searchKey || String(searchKey).trim().length === 0) {
//       setEmployeeOptions([]);
//       return;
//     }

//     fetch(
//       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-employee-by-search-key/?search_key=${encodeURIComponent(
//         searchKey
//       )}`,
//       {
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${localStorage.getItem("other")}`,
//         },
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         const arr = Array.isArray(data) ? data : [];
//         const options = arr.map((emp) => ({
//           // id = user_id if present (so SingleSelectSearchDropdown picks/stores user_id)
//           id: emp.user_id ?? emp.emp_id,
//           label: `${[emp.emp_first_name, emp.emp_middle_name, emp.emp_last_name]
//             .filter(Boolean)
//             .join(" ")} / ${emp.staff_number || "N/A"}`,
//           fullData: emp,
//         }));
//         setEmployeeOptions(options);
//       })
//       .catch((err) => {
//         console.error("Error fetching employee coordinator:", err);
//         setEmployeeOptions([]);
//       });
//   };

//   // Save/Update handler (update-user-group-details) — append group_owner_user_id if present
//   const handleSaveChanges = async () => {
//     if (isInactive()) return;
//     if (!userGroupId) {
//       showMessage("Missing user_group_id", false);
//       return;
//     }

//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Saving user group...</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       setIsMessageBoxVisible(true);
//     }

//     try {
//       const userNameForApi =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name ??
//         localStorage.getItem("username") ??
//         "";
//       const token = localStorage.getItem("other");
//       if (!token) {
//         showMessage("Not authenticated (missing token)", false);
//         return;
//       }

//       const qs = new URLSearchParams({
//         user_group_id: String(userGroupId),
//         group_desc: studentGroupDesc ?? "",
//         // email_flag: String(Number(emailFlag)),
//         // message_flag: String(Number(messageFlag)),
//         email_flag: emailFlag === "True" ? "1" : "0",
//         message_flag: messageFlag === "True" ? "1" : "0",
//         comments: comments ?? "",
//         user_name: userNameForApi ?? "",
//       });

//       if (
//         selectedOwnerUserId !== "" &&
//         selectedOwnerUserId !== null &&
//         typeof selectedOwnerUserId !== "undefined"
//       ) {
//         qs.append("group_owner_user_id", String(selectedOwnerUserId));
//       }

//       const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-user-group-details?${qs.toString()}`;
//       const resp = await fetch(url, {
//         method: "PUT",
//         headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       const json = await resp.json();

//       if (json && json.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{json.message || "User group updated successfully."}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setTimeout(() => setIsMessageBoxVisible(false), 2000);

//         // exit edit mode and update displayed group owner name if possible
//         setEditMode(false);
//         // if employeeOptions contains the selected user id, update visible owner name
//         const found = employeeOptions.find(
//           (o) => String(o.id) === String(selectedOwnerUserId)
//         );
//         if (found) {
//           const label = found.label || "";
//           const ownerName = label.split(" / ")[0] || label;
//           setGroupOwnerName(ownerName);
//         } else {
//           // no change to groupOwnerName if not found
//         }
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {(json && json.message) || "Failed to update user group."}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Save error:", err);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Error while saving user group.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   // Table helpers
//   const handleTableRowSelectionForUserGroups = (newSelectedRows) => {
//     setSelectedUserGroups(newSelectedRows);
//   };

//   const handleDeleteRoleFromGroup = (groupName, roleNameToRemove) => {
//     setGroupedRows((prev) =>
//       prev.map((g) =>
//         g.group_name === groupName
//           ? {
//               ...g,
//               roles: g.roles.filter((r) => r.role_name !== roleNameToRemove),
//             }
//           : g
//       )
//     );
//   };

//   const reviewerGroupLabel = () => {
//     if (quesReviewerGroupId === "NA" || quesReviewerGroupId === null)
//       return "No";
//     // return String(quesReviewerGroupId);
//     return "Yes";
//   };

//   const sampleHeaders = ["User Groups", "Roles", "Screens", "Reports"];

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">User Group Details</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/user_groups_dashboard")}
//           >
//             CANCEL
//           </button>

//           <button
//             className="cr-create-btn"
//             onClick={onDeactivateClicked}
//             disabled={isInactive()}
//             style={{ minWidth: 125, marginLeft: 8 }}
//           >
//             DEACTIVATE
//           </button>

//           {!editMode ? (
//             <button
//               className="cr-create-btn"
//               onClick={() => !isInactive() && setEditMode(true)}
//               disabled={isInactive()}
//               style={{ marginLeft: 8 }}
//             >
//               EDIT
//             </button>
//           ) : (
//             <button
//               className="cr-create-btn"
//               onClick={handleSaveChanges}
//               disabled={isInactive()}
//               style={{ marginLeft: 8 }}
//             >
//               SAVE
//             </button>
//           )}
//         </div>
//       </div>

//       {/* GROUP INFORMATION */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>GROUP INFORMATION</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs
//                   label="User Group Name"
//                   type="text"
//                   required
//                   value={studentGroupName}
//                   onChange={(e) => setStudentGroupName(e.target.value)}
//                   disabled
//                 />
//               </div>

//               <div className="item2">
//                 <FormInputs
//                   label="User Group Description"
//                   type="text"
//                   required
//                   value={studentGroupDesc}
//                   onChange={(e) => setStudentGroupDesc(e.target.value)}
//                   disabled={!editMode}
//                 />
//               </div>

//               <div className="item3">
//                 {!editMode ? (
//                   // <FormInputs
//                   //   label="Message Flag"
//                   //   // value={messageFlag === 1 ? "True" : "False"}
//                   //   value={messageFlag}
//                   //   disabled
//                   // />
//                   <FormInputs
//                     label="Message Flag"
//                     value={
//                       messageFlag == "True" || messageFlag == 1 || messageFlag == "1"
//                         ? "True"
//                         : "False"
//                     }
//                     disabled
//                   />
//                 ) : (
//                   <DropDown
//                     label="Message Flag"
//                     options={[
//                       { id: 1, label: "True" },
//                       { id: 0, label: "False" },
//                     ]}
//                     // selected={messageFlag}
//                     // setSelected={setMessageFlag}
//                     selected={messageFlag === "True" ? 1 : 0}
//                     setSelected={(val) => setMessageFlag(val === 1 ? "True" : "False")}
//                     disabled={!editMode}
//                     placeholder=""
//                   />
//                 )}
//               </div>

//               {/* {console.log("Rendering emailFlag:", emailFlag)} */}
//               {/* {console.log("Rendering messageFlag:", messageFlag)} */}

//               <div className="item4">
//                 {!editMode ? (
//                   // <FormInputs
//                   //   label="Email Flag"
//                   //   // value={emailFlag === 1 ? "True" : "False"}
//                   //   value={emailFlag}
//                   //   disabled
//                   // />
//                   <FormInputs
//                     label="Email Flag"
//                     value={
//                       emailFlag == "True" || emailFlag == 1 || emailFlag == "1"
//                         ? "True"
//                         : "False"
//                     }
//                     disabled
//                   />
//                 ) : (
//                   <DropDown
//                     label="Email Flag"
//                     options={[
//                       { id: 1, label: "True" },
//                       { id: 0, label: "False" },
//                     ]}
//                     // selected={emailFlag}
//                     // setSelected={setEmailFlag}
//                     selected={emailFlag === "True" ? 1 : 0}
//                     setSelected={(val) => setEmailFlag(val === 1 ? "True" : "False")}
//                     disabled={!editMode}
//                     placeholder=""
//                   />
//                 )}
//               </div>

//               <div className="item5">
//                 <FormInputs
//                   label="Created By"
//                   type="text"
//                   value={createdBy}
//                   disabled
//                 />
//               </div>

//               <div className="item6">
//                 {!editMode ? (
//                   <FormInputs
//                     label="Group Owner Name"
//                     value={groupOwnerName || ""}
//                     disabled
//                   />
//                 ) : (
//                   <SingleSelectSearchDropdown
//                     label="Group Owner Name"
//                     width="100%"
//                     singleSelect={true}
//                     selected={selectedOwnerUserId}
//                     setSelected={setSelectedOwnerUserId}
//                     options={employeeOptions}
//                     placeholder="Search and Select Group Owner Name..."
//                     onSearchInputChange={fetchEmployeeCoordinator}
//                     isRequired={false}
//                   />
//                 )}
//               </div>

//               <div className="item7" style={{ gridColumn: "1 / 2" }}>
//                 <FormInputs
//                   label="Last Modified Date"
//                   type="text"
//                   value={lastModifiedDate}
//                   disabled
//                 />
//               </div>

//               <div className="item8" style={{ gridColumn: "2 / 3" }}>
//                 <FormInputs
//                   label="Default Group"
//                   value={defaultUserGroup}
//                   disabled
//                 />
//               </div>

//               <div className="item9" style={{ gridColumn: "3 / 4" }}>
//                 <FormInputs label="Status" value={status} disabled />
//               </div>

//               <div className="item10" style={{ gridColumn: "1 / -1" }}>
//                 <FormInputs
//                   label="Comments"
//                   type="text"
//                   value={comments}
//                   onChange={(e) => setComments(e.target.value)}
//                   disabled={!editMode}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* QUESTION REVIEWER GROUP */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>QUESTION REVIEWER GROUP</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs
//                   label="Is this a Question Reviewer Group?"
//                   type="text"
//                   value={reviewerGroupLabel()}
//                   disabled
//                 />
//               </div>

//               <div className="item2">
//                 {/* <FormInputs label="Course" type="text" value={courseNameField || courseIdField} disabled /> */}
//                 <FormInputs
//                   label="Course"
//                   type="text"
//                   value={courseNameField == "NA" ? "" : courseNameField}
//                   disabled
//                 />
//               </div>

//               <div className="item3">
//                 {/* <FormInputs label="Subject" type="text" value={subjectNameField || subjectIdField} disabled /> */}
//                 <FormInputs
//                   label="Subject"
//                   type="text"
//                   value={subjectNameField == "NA" ? "" : subjectNameField}
//                   disabled
//                 />
//               </div>

//               <div className="item4">
//                 {/* <FormInputs label="HOD or Faculty Reviewer Group?" type="text" value={reviewerGroupType} disabled /> */}
//                 <FormInputs
//                   label="HOD or Faculty Reviewer Group?"
//                   type="text"
//                   value={reviewerGroupType == "NA" ? "" : reviewerGroupType}
//                   disabled
//                 />
//               </div>

//               <div className="item5">
//                 {/* <FormInputs label="Reviewer Level" type="text" value={facultyReviewLevel ? String(facultyReviewLevel) : ""} disabled /> */}
//                 <FormInputs
//                   label="Reviewer Level"
//                   type="text"
//                   value={
//                     facultyReviewLevel == "NA" || facultyReviewLevel == "0"
//                       ? ""
//                       : String(facultyReviewLevel)
//                   }
//                   disabled
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ACCESS INFO table */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ACCESS INFO</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="user-groups-table-container">
//             {Array.isArray(groupedRows) && groupedRows.length > 0 ? (
//               <TableForAccessView
//                 headers={sampleHeaders}
//                 data={groupedRows}
//                 searchPlaceholder="Search access..."
//                 selectedRows={selectedUserGroups}
//                 setSelectedRows={handleTableRowSelectionForUserGroups}
//                 renderQuestionText={(text) => (text ? text : "")}
//                 renderQuestionTextModel={(text) => (text ? text : "")}
//                 expandedStates={{}}
//                 toggleImage={() => {}}
//                 questionDetailsMap={{}}
//                 handleEyeClick={() => {}}
//                 pageType="userGroups"
//                 onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                 filterConfig={{}}
//                 handleDeleteRow={(payload) => {
//                   handleDeleteRoleFromGroup(
//                     payload.groupName,
//                     payload.roleName
//                   );
//                 }}
//               />
//             ) : (
//               <div
//                 style={{
//                   textAlign: "center",
//                   color: "#9b9b9b",
//                   padding: "40px 0",
//                   fontStyle: "italic",
//                 }}
//               >
//                 No screens available
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UserGroupDetails;





















// // UserGroupDetails.jsx
// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "./DropdownPrevValue";
// import SingleSelectSearchDropdown from "../../StudentGrouph/SingleSelectSearchDropdown";
// import TableForAccessView from "../../../Components/TableComponent/TableForAccessView";
// import SuccessImg from ".././../../Assets/Images/CommanImages/Informative.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import { API_BASE_URL } from "../../../Config/Config";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { fetchSessionData } from "../../../Redux/Sessions/sessionSlice";
// import "./updatedusergroup.css";

// // Local uploaded image path (you asked to include it)
// // transform this path to a URL on your side if needed
// const UploadedDebugImagePath = "/mnt/data/c5b4a4b6-1857-4908-af2e-2972c65027d2.png";

// function UserGroupDetails({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();

//   const passedHeaders = location.state?.headers ?? [];
//   const passedRow = location.state?.rowData ?? [];
//   const query = new URLSearchParams(location.search || "");

//   const headerIndexOf = (name) => {
//     if (!Array.isArray(passedHeaders)) return -1;
//     const exact = passedHeaders.findIndex((h) => String(h).trim() === name);
//     if (exact !== -1) return exact;
//     const strippedIndex = passedHeaders.findIndex(
//       (h) =>
//         String(h)
//           .replace(/^[a-z]\*/, "")
//           .trim() === name
//     );
//     if (strippedIndex !== -1) return strippedIndex;
//     const ci = passedHeaders.findIndex(
//       (h) =>
//         String(h)
//           .replace(/^[a-z]\*/, "")
//           .trim()
//           .toLowerCase() === name.toLowerCase()
//     );
//     return ci;
//   };

//   const getValueFromPassed = (name) => {
//     if (!Array.isArray(passedRow) || passedRow.length === 0) return "";
//     const idx = headerIndexOf(name);
//     if (idx === -1) return "";
//     const v = passedRow[idx];
//     return v === null || v === undefined ? "" : v;
//   };

//   const findValue = (names) => {
//     for (const n of names) {
//       const v = getValueFromPassed(n);
//       if (v !== "") return v;
//       const q = query.get(n) ?? query.get(n.replace(/\s+/g, ""));
//       if (q) return q;
//     }
//     return "";
//   };

//   // --- initial states (read once or via effect below) ---
//   const [userGroupId] = useState(() =>
//     findValue(["User Group ID", "UserGroupId", "UserGroupID"])
//   );
//   const [studentGroupName, setStudentGroupName] = useState(() =>
//     findValue(["User Group Name", "UserGroupName", "t*User Group Name"])
//   );
//   const [studentGroupDesc, setStudentGroupDesc] = useState(() =>
//     findValue([
//       "User Group Description",
//       "UserGroupDescription",
//       "t*User Group Description",
//     ])
//   );

//   // flags
//   const initialMessageFlag = (() => {
//     const v = findValue(["Message Flag", "MessageFlag", "t*Message Flag"]);
//     if (v === "" || v === null) return 0;
//     return Number(v) === 1 ? 1 : 0;
//   })();
//   const initialEmailFlag = (() => {
//     const v = findValue(["Email Flag", "EmailFlag", "t*Email Flag"]);
//     if (v === "" || v === null) return 0;
//     return Number(v) === 1 ? 1 : 0;
//   })();

//   const [messageFlag, setMessageFlag] = useState(initialMessageFlag);
//   const [emailFlag, setEmailFlag] = useState(initialEmailFlag);

//   const [comments, setComments] = useState(() =>
//     findValue(["Comments", "t*Comments"])
//   );
//   const [status, setStatus] = useState(() => {
//     const v = findValue(["Status", "t*Status"]);
//     if (String(v) === "0") return "Inactive";
//     return v || "";
//   });
//   const [lastModifiedDate, setLastModifiedDate] = useState(() =>
//     findValue([
//       "Last Modified Date",
//       "LastModifiedDate",
//       "d*Last Modified Date",
//     ])
//   );
//   const [createdBy, setCreatedBy] = useState(() =>
//     findValue(["Created By", "CreatedBy", "t*Created By"])
//   );
//   const [groupOwnerName, setGroupOwnerName] = useState(() =>
//     findValue(["Group Owner Name", "GroupOwnerName", "t*Group Owner Name"])
//   );
//   const [defaultUserGroup, setDefaultUserGroup] = useState(() =>
//     findValue(["Default Group", "DefaultUserGroup", "t*Default Group"])
//   );

//   // reviewer group fields
//   const [quesReviewerGroupId, setQuesReviewerGroupId] = useState(() =>
//     findValue([
//       "Ques Reviewer Group ID",
//       "QuesReviewerGroupID",
//       "n*Ques Reviewer Group ID",
//     ])
//   );
//   const [courseIdField, setCourseIdField] = useState(() =>
//     findValue(["Course ID", "CourseID", "n*Course ID"])
//   );
//   const [courseNameField, setCourseNameField] = useState(() =>
//     findValue(["Course Name", "CourseName", "t*Course Name"])
//   );
//   const [subjectIdField, setSubjectIdField] = useState(() =>
//     findValue(["Subject ID", "SubjectID", "n*Subject ID"])
//   );
//   const [subjectNameField, setSubjectNameField] = useState(() =>
//     findValue(["Subject Name", "SubjectName", "t*Subject Name"])
//   );
//   const [reviewerGroupType, setReviewerGroupType] = useState(() =>
//     findValue([
//       "Reviewer Group Type",
//       "ReviewerGroupType",
//       "t*Reviewer Group Type",
//     ])
//   );
//   const [facultyReviewLevel, setFacultyReviewLevel] = useState(() =>
//     findValue([
//       "Faculty Review Level",
//       "FacultyReviewLevel",
//       "n*Faculty Review Level",
//     ])
//   );

//   // access table
//   const [groupedRows, setGroupedRows] = useState([]);
//   const [selectedUserGroups, setSelectedUserGroups] = useState([]);
//   const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);

//   // fetch courses/sessions
//   useEffect(() => {
//     dispatch(fetchCourseData());
//     dispatch(fetchSessionData());
//   }, [dispatch]);

//   // Mirror incoming props/state into local state (also set selectedOwnerUserId here)
//   useEffect(() => {
//     setStudentGroupName(
//       findValue(["User Group Name", "UserGroupName", "t*User Group Name"])
//     );
//     setStudentGroupDesc(
//       findValue([
//         "User Group Description",
//         "UserGroupDescription",
//         "t*User Group Description",
//       ])
//     );

//     setMessageFlag(
//       (() => {
//         const v = findValue(["Message Flag", "MessageFlag", "t*Message Flag"]);
//         return v == "True" ? "True" : "False";
//       })()
//     );
//     setEmailFlag(
//       (() => {
//         const v = findValue(["Email Flag", "EmailFlag", "t*Email Flag"]);
//         return v == "True" ? "True" : "False";
//       })()
//     );

//     setComments(findValue(["Comments", "t*Comments"]));
//     setStatus(
//       (() => {
//         const v = findValue(["Status", "t*Status"]);
//         return String(v) === "0" ? "Inactive" : v || "";
//       })()
//     );
//     setLastModifiedDate(
//       findValue([
//         "Last Modified Date",
//         "LastModifiedDate",
//         "d*Last Modified Date",
//       ])
//     );
//     setCreatedBy(findValue(["Created By", "CreatedBy", "t*Created By"]));
//     setGroupOwnerName(
//       findValue(["Group Owner Name", "GroupOwnerName", "t*Group Owner Name"])
//     );
//     setDefaultUserGroup(
//       findValue(["Default Group", "DefaultUserGroup", "t*Default Group"])
//     );
//     setQuesReviewerGroupId(
//       findValue([
//         "Ques Reviewer Group ID",
//         "QuesReviewerGroupID",
//         "n*Ques Reviewer Group ID",
//       ])
//     );
//     setCourseIdField(findValue(["Course ID", "CourseID", "n*Course ID"]));
//     setCourseNameField(
//       findValue(["Course Name", "CourseName", "t*Course Name"])
//     );
//     setSubjectIdField(findValue(["Subject ID", "SubjectID", "n*Subject ID"]));
//     setSubjectNameField(
//       findValue(["Subject Name", "SubjectName", "t*Subject Name"])
//     );
//     setReviewerGroupType(
//       findValue([
//         "Reviewer Group Type",
//         "ReviewerGroupType",
//         "t*Reviewer Group Type",
//       ])
//     );
//     setFacultyReviewLevel(
//       findValue([
//         "Faculty Review Level",
//         "FacultyReviewLevel",
//         "n*Faculty Review Level",
//       ])
//     );

//     // --- ensure selectedOwnerUserId is set from incoming data so EDIT shows it ---
//     const incomingOwnerId = findValue([
//       "Group Owner User ID",
//       "GroupOwnerUserID",
//       "group_owner_user_id",
//       "n*Group Owner User ID",
//     ]);
//     if (incomingOwnerId !== "" && incomingOwnerId !== null && typeof incomingOwnerId !== "undefined") {
//       setSelectedOwnerUserId(String(incomingOwnerId));
//     } else {
//       setSelectedOwnerUserId("");
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [location.state]);

//   const showMessage = (text, success = true) => {
//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{text}</span>
//           </div>
//         </div>
//       );
//       // use your existing images for feedback
//       setActiveImg(success ? SuccessImg : ErrorImg);
//       setIsMessageBoxVisible(true);
//       setTimeout(() => setIsMessageBoxVisible(false), 2500);
//     } else {
//       console.log("MSG:", text);
//     }
//   };

//   const isInactive = () => {
//     const s = String(status || "").toLowerCase();
//     return s === "inactive" || s === "0";
//   };

//   // default group check: treat "True", "true", 1, "1" as true
//   const isDefaultGroup = () => {
//     const v = defaultUserGroup;
//     return (
//       v === true ||
//       v === "True" ||
//       v === "true" ||
//       v === 1 ||
//       v === "1" ||
//       String(v).toLowerCase() === "true"
//     );
//   };

//   // fetch roles/screens/reports for this user group from API
//   useEffect(() => {
//     async function fetchRolesForGroup() {
//       if (!userGroupId) {
//         setGroupedRows([]);
//         return;
//       }

//       try {
//         const token = localStorage.getItem("other");
//         const qs = new URLSearchParams({ user_group_id: String(userGroupId) });
//         const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-user-group-role-screen-report-access-details-by-user-id?${qs.toString()}`;

//         const res = await fetch(url, {
//           method: "GET",
//           headers: {
//             Accept: "application/json",
//             ...(token ? { Authorization: `Bearer ${token}` } : {}),
//           },
//         });

//         const json = await res.json();

//         if (
//           res.ok &&
//           json &&
//           json.status === 200 &&
//           Array.isArray(json.data) &&
//           json.data.length > 0
//         ) {
//           setGroupedRows(json.data);
//         } else {
//           setGroupedRows([]);
//         }
//       } catch (err) {
//         console.error("Failed to fetch roles for group:", err);
//         setGroupedRows([]);
//         showMessage("Error fetching roles for user group", false);
//       }
//     }

//     fetchRolesForGroup();
//   }, [userGroupId]);

//   // Deactivate/Activate flow - single handler
//   const onToggleActiveClicked = () => {
//     if (isDefaultGroup()) return; // respect disable rule for default group
//     if (isInactive()) {
//       // Activate
//       confirmToggleActive(true);
//     } else {
//       // Deactivate
//       confirmToggleActive(false);
//     }
//   };

//   const confirmToggleActive = (activate) => {
//     if (!setMessageBox) {
//       const confirmMsg = activate
//         ? "Are you sure you want to activate this user group?"
//         : "Are you sure you want to deactivate this user group, members of this group will loose thier rights?";
//       if (window.confirm(confirmMsg)) {
//         handleToggleActiveConfirmed(activate);
//       }
//       return;
//     }

//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>
//             {activate
//               ? "Are you sure you want to activate this user group?"
//               : "Are you sure you want to deactivate this user group, members of this group will loose thier rights?"}
//           </span>
//         </div>
//         <div
//           className="messagebox-insider2"
//           style={{
//             display: "flex",
//             gap: "10px",
//             marginTop: "10px",
//             justifyContent: "flex-end",
//           }}
//         >
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={async () => {
//               setIsMessageBoxVisible(false);
//               await handleToggleActiveConfirmed(activate);
//             }}
//           >
//             YES
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//             }}
//           >
//             NO
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//     setIsMessageBoxVisible(true);
//   };

//   const handleToggleActiveConfirmed = async (activate) => {
//     if (!userGroupId) {
//       showMessage("Missing user_group_id", false);
//       return;
//     }

//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{activate ? "Activating user group..." : "Deactivating user group..."}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       setIsMessageBoxVisible(true);
//     }

//     try {
//       const userNameForApi =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name ??
//         localStorage.getItem("username") ??
//         "";
//       const token = localStorage.getItem("other");
//       if (!token) {
//         showMessage("Not authenticated (missing token)", false);
//         return;
//       }

//       // Use same API as deactivate — set status to '1' for activate, '0' for deactivate
//       const qs = new URLSearchParams({
//         user_group_id: String(userGroupId),
//         comments: comments ?? "",
//         status: activate ? "1" : "0",
//         modified_by: userNameForApi ?? "",
//       });

//       const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/deactivate-user-group?${qs.toString()}`;
//       const resp = await fetch(url, {
//         method: "PUT",
//         headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       const json = await resp.json();

//       if (json && json.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{json.message || (activate ? "User group activated successfully!" : "User group deactivated successfully!")}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setStatus(activate ? "Active" : "Inactive");
//         setTimeout(() => setIsMessageBoxVisible(false), 2000);
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {(json && json.message) || (activate ? "Failed to activate user group." : "Failed to deactivate user group.")}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Toggle active error:", err);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Error while updating user group status.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   // --- edit state + group-owner selection logic ---
//   const [editMode, setEditMode] = useState(false);

//   // employee search options used by the owner selection dropdown
//   const [employeeOptions, setEmployeeOptions] = useState([]);
//   // selectedOwnerUserId stores the employee's user_id (as required by update API)
//   const [selectedOwnerUserId, setSelectedOwnerUserId] = useState(() => {
//     const v = findValue([
//       "Group Owner User ID",
//       "GroupOwnerUserID",
//       "group_owner_user_id",
//       "n*Group Owner User ID",
//     ]);
//     return v === null || v === undefined || v === "" ? "" : String(v);
//   });

//   // Ensure placeholder option exists when entering edit mode
//   useEffect(() => {
//     if (!editMode) return;

//     if (selectedOwnerUserId && selectedOwnerUserId !== "") {
//       const exists = employeeOptions.some(
//         (o) => String(o.id) === String(selectedOwnerUserId)
//       );
//       if (!exists) {
//         const placeholderLabel =
//           (groupOwnerName && String(groupOwnerName).trim()) || "Current Owner";
//         const placeholder = {
//           id: selectedOwnerUserId,
//           label: `${placeholderLabel} / N/A`,
//           fullData: { emp_first_name: placeholderLabel },
//         };
//         setEmployeeOptions((prev) => {
//           const already = prev.some(
//             (p) => String(p.id) === String(selectedOwnerUserId)
//           );
//           if (already) return prev;
//           return [placeholder, ...prev];
//         });
//       }
//     } else {
//       // remove any placeholder for empty owner
//       setEmployeeOptions((prev) =>
//         prev.filter((p) => String(p.id) !== String(selectedOwnerUserId))
//       );
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [editMode, selectedOwnerUserId, groupOwnerName]);

//   // fetch employees for group owner search (maps to user_id)
//   const fetchEmployeeCoordinator = (searchKey) => {
//     if (!searchKey || String(searchKey).trim().length === 0) {
//       setEmployeeOptions((prev) =>
//         prev.filter((p) => String(p.id) === String(selectedOwnerUserId))
//       );
//       return;
//     }

//     fetch(
//       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-employee-by-search-key/?search_key=${encodeURIComponent(
//         searchKey
//       )}`,
//       {
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${localStorage.getItem("other")}`,
//         },
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         const arr = Array.isArray(data) ? data : [];
//         const options = arr.map((emp) => ({
//           id: emp.user_id ?? emp.emp_id,
//           label: `${[emp.emp_first_name, emp.emp_middle_name, emp.emp_last_name]
//             .filter(Boolean)
//             .join(" ")} / ${emp.staff_number || "N/A"}`,
//           fullData: emp,
//         }));

//         setEmployeeOptions((prev) => {
//           const placeholder = prev.find(
//             (p) => String(p.id) === String(selectedOwnerUserId)
//           );
//           const merged = options.filter(
//             (o) => String(o.id) !== String(selectedOwnerUserId)
//           );
//           return placeholder ? [placeholder, ...merged] : merged;
//         });
//       })
//       .catch((err) => {
//         console.error("Error fetching employee coordinator:", err);
//         setEmployeeOptions((prev) =>
//           prev.filter((p) => String(p.id) === String(selectedOwnerUserId))
//         );
//       });
//   };

//   // Save/Update handler (update-user-group-details)
//   // Only append group_owner_user_id if non-empty (when cleared we omit param)
//   const handleSaveChanges = async () => {
//     if (isInactive()) return;
//     if (!userGroupId) {
//       showMessage("Missing user_group_id", false);
//       return;
//     }

//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Saving user group...</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       setIsMessageBoxVisible(true);
//     }

//     try {
//       const userNameForApi =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name ??
//         localStorage.getItem("username") ??
//         "";
//       const token = localStorage.getItem("other");
//       if (!token) {
//         showMessage("Not authenticated (missing token)", false);
//         return;
//       }

//       const qs = new URLSearchParams({
//         user_group_id: String(userGroupId),
//         group_desc: studentGroupDesc ?? "",
//         email_flag: emailFlag === "True" ? "1" : "0",
//         message_flag: messageFlag === "True" ? "1" : "0",
//         comments: comments ?? "",
//         user_name: userNameForApi ?? "",
//       });

//       // only append group_owner_user_id when present (omit on clear)
//       if (
//         selectedOwnerUserId !== null &&
//         selectedOwnerUserId !== undefined &&
//         selectedOwnerUserId !== ""
//       ) {
//         qs.append("group_owner_user_id", String(selectedOwnerUserId));
//       }

//       const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-user-group-details?${qs.toString()}`;
//       const resp = await fetch(url, {
//         method: "PUT",
//         headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       const json = await resp.json();

//       if (json && json.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{json.message || "User group updated successfully."}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setTimeout(() => setIsMessageBoxVisible(false), 2000);

//         // exit edit mode and update displayed group owner name if possible
//         setEditMode(false);
//         const found = employeeOptions.find(
//           (o) => String(o.id) === String(selectedOwnerUserId)
//         );
//         if (found) {
//           const label = found.label || "";
//           const ownerName = label.split(" / ")[0] || label;
//           setGroupOwnerName(ownerName);
//         } else {
//           if (!selectedOwnerUserId) {
//             setGroupOwnerName("");
//           }
//         }
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {(json && json.message) || "Failed to update user group."}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Save error:", err);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Error while saving user group.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   // Table helpers
//   const handleTableRowSelectionForUserGroups = (newSelectedRows) => {
//     setSelectedUserGroups(newSelectedRows);
//   };

//   const handleDeleteRoleFromGroup = (groupName, roleNameToRemove) => {
//     setGroupedRows((prev) =>
//       prev.map((g) =>
//         g.group_name === groupName
//           ? {
//               ...g,
//               roles: g.roles.filter((r) => r.role_name !== roleNameToRemove),
//             }
//           : g
//       )
//     );
//   };

//   const reviewerGroupLabel = () => {
//     if (quesReviewerGroupId === "NA" || quesReviewerGroupId === null)
//       return "No";
//     return "Yes";
//   };

//   const sampleHeaders = ["User Groups", "Roles", "Screens", "Reports"];

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">User Group Details</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/user_groups_dashboard")}
//           >
//             CANCEL
//           </button>

//           <button
//             className="cr-create-btn"
//             onClick={onToggleActiveClicked}
//             disabled={isDefaultGroup()} // disable when default group
//             style={{ minWidth: 125, marginLeft: 8 }}
//           >
//             {/* Show ACTIVATE when inactive, DEACTIVATE when active */}
//             {isInactive() ? "ACTIVATE" : "DEACTIVATE"}
//           </button>

//           {!editMode ? (
//             <button
//               className="cr-create-btn"
//               onClick={() => !isInactive() && setEditMode(true)}
//               disabled={isDefaultGroup()} // disable EDIT when default group
//               style={{ marginLeft: 8 }}
//             >
//               EDIT
//             </button>
//           ) : (
//             <button
//               className="cr-create-btn"
//               onClick={handleSaveChanges}
//               disabled={isInactive()}
//               style={{ marginLeft: 8 }}
//             >
//               SAVE
//             </button>
//           )}
//         </div>
//       </div>

//       {/* GROUP INFORMATION */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>GROUP INFORMATION</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs
//                   label="User Group Name"
//                   type="text"
//                   required
//                   value={studentGroupName}
//                   onChange={(e) => setStudentGroupName(e.target.value)}
//                   disabled
//                 />
//               </div>

//               <div className="item2">
//                 <FormInputs
//                   label="User Group Description"
//                   type="text"
//                   required
//                   value={studentGroupDesc}
//                   onChange={(e) => setStudentGroupDesc(e.target.value)}
//                   disabled={!editMode}
//                 />
//               </div>

//               <div className="item3">
//                 {!editMode ? (
//                   <FormInputs
//                     label="Message Enabled"
//                     value={
//                       messageFlag == "True" ||
//                       messageFlag == 1 ||
//                       messageFlag == "1"
//                         ? "True"
//                         : "False"
//                     }
//                     disabled
//                   />
//                 ) : (
//                   <DropDown
//                     label="Message Enabled"
//                     options={[
//                       { id: 1, label: "True" },
//                       { id: 0, label: "False" },
//                     ]}
//                     selected={messageFlag === "True" ? 1 : 0}
//                     setSelected={(val) =>
//                       setMessageFlag(val === 1 ? "True" : "False")
//                     }
//                     disabled={!editMode}
//                     placeholder=""
//                   />
//                 )}
//               </div>

//               <div className="item4">
//                 {!editMode ? (
//                   <FormInputs
//                     label="Email Enabled"
//                     value={
//                       emailFlag == "True" || emailFlag == 1 || emailFlag == "1"
//                         ? "True"
//                         : "False"
//                     }
//                     disabled
//                   />
//                 ) : (
//                   <DropDown
//                     label="Email Enabled"
//                     options={[
//                       { id: 1, label: "True" },
//                       { id: 0, label: "False" },
//                     ]}
//                     selected={emailFlag === "True" ? 1 : 0}
//                     setSelected={(val) => setEmailFlag(val === 1 ? "True" : "False")}
//                     disabled={!editMode}
//                     placeholder=""
//                   />
//                 )}
//               </div>

//               <div className="item5">
//                 <FormInputs
//                   label="Created By"
//                   type="text"
//                   value={createdBy}
//                   disabled
//                 />
//               </div>

//               <div className="item6">
//                 {!editMode ? (
//                   <FormInputs
//                     label="Group Owner Name"
//                     value={groupOwnerName || ""}
//                     disabled
//                   />
//                 ) : (
//                   <SingleSelectSearchDropdown
//                     label="Group Owner Name"
//                     width="100%"
//                     singleSelect={true}
//                     selected={selectedOwnerUserId}
//                     setSelected={(val) => {
//                       setSelectedOwnerUserId(
//                         val === null || val === undefined || val === "" ? "" : String(val)
//                       );
//                     }}
//                     options={employeeOptions}
//                     placeholder="Search and Select Group Owner Name..."
//                     onSearchInputChange={fetchEmployeeCoordinator}
//                     isRequired={false}
//                   />
//                 )}
//               </div>

//               <div className="item7" style={{ gridColumn: "1 / 2" }}>
//                 <FormInputs
//                   label="Last Modified Date"
//                   type="text"
//                   value={lastModifiedDate}
//                   disabled
//                 />
//               </div>

//               <div className="item8" style={{ gridColumn: "2 / 3" }}>
//                 <FormInputs
//                   label="Default Group"
//                   value={defaultUserGroup}
//                   disabled
//                 />
//               </div>

//               <div className="item9" style={{ gridColumn: "3 / 4" }}>
//                 <FormInputs label="Status" value={status} disabled />
//               </div>

//               <div className="item10" style={{ gridColumn: "1 / -1" }}>
//                 <FormInputs
//                   label="Comments"
//                   type="text"
//                   value={comments}
//                   onChange={(e) => setComments(e.target.value)}
//                   disabled={!editMode}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* QUESTION REVIEWER GROUP */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>QUESTION REVIEWER GROUP</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs
//                   label="Is this a Question Reviewer Group?"
//                   type="text"
//                   value={reviewerGroupLabel()}
//                   disabled
//                 />
//               </div>

//               <div className="item2">
//                 <FormInputs
//                   label="Course"
//                   type="text"
//                   value={courseNameField == "NA" ? "" : courseNameField}
//                   disabled
//                 />
//               </div>

//               <div className="item3">
//                 <FormInputs
//                   label="Subject"
//                   type="text"
//                   value={subjectNameField == "NA" ? "" : subjectNameField}
//                   disabled
//                 />
//               </div>

//               <div className="item4">
//                 <FormInputs
//                   label="HOD or Faculty Reviewer Group?"
//                   type="text"
//                   value={reviewerGroupType == "NA" ? "" : reviewerGroupType}
//                   disabled
//                 />
//               </div>

//               <div className="item5">
//                 <FormInputs
//                   label="Reviewer Level"
//                   type="text"
//                   value={
//                     facultyReviewLevel == "NA" || facultyReviewLevel == "0"
//                       ? ""
//                       : String(facultyReviewLevel)
//                   }
//                   disabled
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ACCESS INFO table */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ACCESS INFO</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="user-groups-table-container">
//             {Array.isArray(groupedRows) && groupedRows.length > 0 ? (
//               <TableForAccessView
//                 headers={sampleHeaders}
//                 data={groupedRows}
//                 searchPlaceholder="Search access..."
//                 selectedRows={selectedUserGroups}
//                 setSelectedRows={handleTableRowSelectionForUserGroups}
//                 renderQuestionText={(text) => (text ? text : "")}
//                 renderQuestionTextModel={(text) => (text ? text : "")}
//                 expandedStates={{}}
//                 toggleImage={() => {}}
//                 questionDetailsMap={{}}
//                 handleEyeClick={() => {}}
//                 pageType="userGroups"
//                 onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                 filterConfig={{}}
//                 handleDeleteRow={(payload) => {
//                   handleDeleteRoleFromGroup(payload.groupName, payload.roleName);
//                 }}
//               />
//             ) : (
//               <div
//                 style={{
//                   textAlign: "center",
//                   color: "#9b9b9b",
//                   padding: "40px 0",
//                   fontStyle: "italic",
//                 }}
//               >
//                 No screens available
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UserGroupDetails;




















// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "./DropdownPrevValue";
// import SingleSelectSearchDropdown from "../../StudentGrouph/SingleSelectSearchDropdown";
// import TableForAccessView from "../../../Components/TableComponent/TableForAccessView";
// import SuccessImg from ".././../../Assets/Images/CommanImages/Informative.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import { API_BASE_URL } from "../../../Config/Config";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { fetchSessionData } from "../../../Redux/Sessions/sessionSlice";
// import "./updatedusergroup.css";

// // Local uploaded image path (you asked to include it)
// // transform this path to a URL on your side if needed
// const UploadedDebugImagePath = "/mnt/data/c5b4a4b6-1857-4908-af2e-2972c65027d2.png";

// // Helper: consider NA / N/A (case-insensitive) as empty/no-value
// const isMeaningfulId = (v) => {
//   if (v === null || v === undefined) return false;
//   const s = String(v).trim();
//   if (s === "") return false;
//   const up = s.toUpperCase();
//   if (up === "NA" || up === "N/A") return false;
//   return true;
// };

// function UserGroupDetails({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();

//   const passedHeaders = location.state?.headers ?? [];
//   const passedRow = location.state?.rowData ?? [];
//   const query = new URLSearchParams(location.search || "");

//   const headerIndexOf = (name) => {
//     if (!Array.isArray(passedHeaders)) return -1;
//     const exact = passedHeaders.findIndex((h) => String(h).trim() === name);
//     if (exact !== -1) return exact;
//     const strippedIndex = passedHeaders.findIndex(
//       (h) =>
//         String(h)
//           .replace(/^[a-z]\*/, "")
//           .trim() === name
//     );
//     if (strippedIndex !== -1) return strippedIndex;
//     const ci = passedHeaders.findIndex(
//       (h) =>
//         String(h)
//           .replace(/^[a-z]\*/, "")
//           .trim()
//           .toLowerCase() === name.toLowerCase()
//     );
//     return ci;
//   };

//   const getValueFromPassed = (name) => {
//     if (!Array.isArray(passedRow) || passedRow.length === 0) return "";
//     const idx = headerIndexOf(name);
//     if (idx === -1) return "";
//     const v = passedRow[idx];
//     return v === null || v === undefined ? "" : v;
//   };

//   const findValue = (names) => {
//     for (const n of names) {
//       const v = getValueFromPassed(n);
//       if (v !== "") return v;
//       const q = query.get(n) ?? query.get(n.replace(/\s+/g, ""));
//       if (q) return q;
//     }
//     return "";
//   };

//   // --- initial states (read once or via effect below) ---
//   const [userGroupId] = useState(() =>
//     findValue(["User Group ID", "UserGroupId", "UserGroupID"])
//   );
//   const [studentGroupName, setStudentGroupName] = useState(() =>
//     findValue(["User Group Name", "UserGroupName", "t*User Group Name"])
//   );
//   const [studentGroupDesc, setStudentGroupDesc] = useState(() =>
//     findValue([
//       "User Group Description",
//       "UserGroupDescription",
//       "t*User Group Description",
//     ])
//   );

//   // flags
//   const initialMessageFlag = (() => {
//     const v = findValue(["Message Flag", "MessageFlag", "t*Message Flag"]);
//     if (v === "" || v === null) return 0;
//     return Number(v) === 1 ? 1 : 0;
//   })();
//   const initialEmailFlag = (() => {
//     const v = findValue(["Email Flag", "EmailFlag", "t*Email Flag"]);
//     if (v === "" || v === null) return 0;
//     return Number(v) === 1 ? 1 : 0;
//   })();

//   const [messageFlag, setMessageFlag] = useState(initialMessageFlag);
//   const [emailFlag, setEmailFlag] = useState(initialEmailFlag);

//   const [comments, setComments] = useState(() =>
//     findValue(["Comments", "t*Comments"])
//   );
//   const [status, setStatus] = useState(() => {
//     const v = findValue(["Status", "t*Status"]);
//     if (String(v) === "0") return "Inactive";
//     return v || "";
//   });
//   const [lastModifiedDate, setLastModifiedDate] = useState(() =>
//     findValue([
//       "Last Modified Date",
//       "LastModifiedDate",
//       "d*Last Modified Date",
//     ])
//   );
//   const [createdBy, setCreatedBy] = useState(() =>
//     findValue(["Created By", "CreatedBy", "t*Created By"])
//   );
//   const [groupOwnerName, setGroupOwnerName] = useState(() =>
//     findValue(["Group Owner Name", "GroupOwnerName", "t*Group Owner Name"])
//   );
//   const [defaultUserGroup, setDefaultUserGroup] = useState(() =>
//     findValue(["Default Group", "DefaultUserGroup", "t*Default Group"])
//   );

//   // reviewer group fields
//   const [quesReviewerGroupId, setQuesReviewerGroupId] = useState(() =>
//     findValue([
//       "Ques Reviewer Group ID",
//       "QuesReviewerGroupID",
//       "n*Ques Reviewer Group ID",
//     ])
//   );
//   const [courseIdField, setCourseIdField] = useState(() =>
//     findValue(["Course ID", "CourseID", "n*Course ID"])
//   );
//   const [courseNameField, setCourseNameField] = useState(() =>
//     findValue(["Course Name", "CourseName", "t*Course Name"])
//   );
//   const [subjectIdField, setSubjectIdField] = useState(() =>
//     findValue(["Subject ID", "SubjectID", "n*Subject ID"])
//   );
//   const [subjectNameField, setSubjectNameField] = useState(() =>
//     findValue(["Subject Name", "SubjectName", "t*Subject Name"])
//   );
//   const [reviewerGroupType, setReviewerGroupType] = useState(() =>
//     findValue([
//       "Reviewer Group Type",
//       "ReviewerGroupType",
//       "t*Reviewer Group Type",
//     ])
//   );
//   const [facultyReviewLevel, setFacultyReviewLevel] = useState(() =>
//     findValue([
//       "Faculty Review Level",
//       "FacultyReviewLevel",
//       "n*Faculty Review Level",
//     ])
//   );

//   // access table
//   const [groupedRows, setGroupedRows] = useState([]);
//   const [selectedUserGroups, setSelectedUserGroups] = useState([]);
//   const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);

//   // fetch courses/sessions
//   useEffect(() => {
//     dispatch(fetchCourseData());
//     dispatch(fetchSessionData());
//   }, [dispatch]);

//   // Mirror incoming props/state into local state (also set selectedOwnerUserId here)
//   useEffect(() => {
//     setStudentGroupName(
//       findValue(["User Group Name", "UserGroupName", "t*User Group Name"])
//     );
//     setStudentGroupDesc(
//       findValue([
//         "User Group Description",
//         "UserGroupDescription",
//         "t*User Group Description",
//       ])
//     );

//     setMessageFlag(
//       (() => {
//         const v = findValue(["Message Flag", "MessageFlag", "t*Message Flag"]);
//         return v == "True" ? "True" : "False";
//       })()
//     );
//     setEmailFlag(
//       (() => {
//         const v = findValue(["Email Flag", "EmailFlag", "t*Email Flag"]);
//         return v == "True" ? "True" : "False";
//       })()
//     );

//     setComments(findValue(["Comments", "t*Comments"]));
//     setStatus(
//       (() => {
//         const v = findValue(["Status", "t*Status"]);
//         return String(v) === "0" ? "Inactive" : v || "";
//       })()
//     );
//     setLastModifiedDate(
//       findValue([
//         "Last Modified Date",
//         "LastModifiedDate",
//         "d*Last Modified Date",
//       ])
//     );
//     setCreatedBy(findValue(["Created By", "CreatedBy", "t*Created By"]));
//     setGroupOwnerName(
//       findValue(["Group Owner Name", "GroupOwnerName", "t*Group Owner Name"])
//     );
//     setDefaultUserGroup(
//       findValue(["Default Group", "DefaultUserGroup", "t*Default Group"])
//     );
//     setQuesReviewerGroupId(
//       findValue([
//         "Ques Reviewer Group ID",
//         "QuesReviewerGroupID",
//         "n*Ques Reviewer Group ID",
//       ])
//     );
//     setCourseIdField(findValue(["Course ID", "CourseID", "n*Course ID"]));
//     setCourseNameField(
//       findValue(["Course Name", "CourseName", "t*Course Name"])
//     );
//     setSubjectIdField(findValue(["Subject ID", "SubjectID", "n*Subject ID"]));
//     setSubjectNameField(
//       findValue(["Subject Name", "SubjectName", "t*Subject Name"])
//     );
//     setReviewerGroupType(
//       findValue([
//         "Reviewer Group Type",
//         "ReviewerGroupType",
//         "t*Reviewer Group Type",
//       ])
//     );
//     setFacultyReviewLevel(
//       findValue([
//         "Faculty Review Level",
//         "FacultyReviewLevel",
//         "n*Faculty Review Level",
//       ])
//     );

//     // --- ensure selectedOwnerUserId is set from incoming data so EDIT shows it ---
//     const incomingOwnerId = findValue([
//       "Group Owner User ID",
//       "GroupOwnerUserID",
//       "group_owner_user_id",
//       "n*Group Owner User ID",
//     ]);

//     // Treat NA / N/A as empty (no owner)
//     if (isMeaningfulId(incomingOwnerId)) {
//       setSelectedOwnerUserId(String(incomingOwnerId));
//     } else {
//       // keep selectedOwnerUserId empty if incoming value is "NA" or missing
//       setSelectedOwnerUserId("");
//       // ensure read-only label shows NA if incoming label was NA/empty
//       const incomingOwnerLabel = findValue([
//         "Group Owner Name",
//         "GroupOwnerName",
//         "t*Group Owner Name",
//       ]);
//       if (!isMeaningfulId(incomingOwnerLabel)) {
//         setGroupOwnerName("NA");
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [location.state]);

//   const showMessage = (text, success = true) => {
//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{text}</span>
//           </div>
//         </div>
//       );
//       // use your existing images for feedback
//       setActiveImg(success ? SuccessImg : ErrorImg);
//       setIsMessageBoxVisible(true);
//       setTimeout(() => setIsMessageBoxVisible(false), 2500);
//     } else {
//       console.log("MSG:", text);
//     }
//   };

//   const isInactive = () => {
//     const s = String(status || "").toLowerCase();
//     return s === "inactive" || s === "0";
//   };

//   // default group check: treat "True", "true", 1, "1" as true
//   const isDefaultGroup = () => {
//     const v = defaultUserGroup;
//     return (
//       v === true ||
//       v === "True" ||
//       v === "true" ||
//       v === 1 ||
//       v === "1" ||
//       String(v).toLowerCase() === "true"
//     );
//   };

//   // fetch roles/screens/reports for this user group from API
//   useEffect(() => {
//     async function fetchRolesForGroup() {
//       if (!userGroupId) {
//         setGroupedRows([]);
//         return;
//       }

//       try {
//         const token = localStorage.getItem("other");
//         const qs = new URLSearchParams({ user_group_id: String(userGroupId) });
//         const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-user-group-role-screen-report-access-details-by-user-id?${qs.toString()}`;

//         const res = await fetch(url, {
//           method: "GET",
//           headers: {
//             Accept: "application/json",
//             ...(token ? { Authorization: `Bearer ${token}` } : {}),
//           },
//         });

//         const json = await res.json();

//         if (
//           res.ok &&
//           json &&
//           json.status === 200 &&
//           Array.isArray(json.data) &&
//           json.data.length > 0
//         ) {
//           setGroupedRows(json.data);
//         } else {
//           setGroupedRows([]);
//         }
//       } catch (err) {
//         console.error("Failed to fetch roles for group:", err);
//         setGroupedRows([]);
//         showMessage("Error fetching roles for user group", false);
//       }
//     }

//     fetchRolesForGroup();
//   }, [userGroupId]);

//   // Deactivate/Activate flow - single handler
//   const onToggleActiveClicked = () => {
//     if (isDefaultGroup()) return; // respect disable rule for default group
//     if (isInactive()) {
//       // Activate
//       confirmToggleActive(true);
//     } else {
//       // Deactivate
//       confirmToggleActive(false);
//     }
//   };

//   const confirmToggleActive = (activate) => {
//     if (!setMessageBox) {
//       const confirmMsg = activate
//         ? "Are you sure you want to activate this user group?"
//         : "Are you sure you want to deactivate this user group, members of this group will loose thier rights?";
//       if (window.confirm(confirmMsg)) {
//         handleToggleActiveConfirmed(activate);
//       }
//       return;
//     }

//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>
//             {activate
//               ? "Are you sure you want to activate this user group?"
//               : "Are you sure you want to deactivate this user group, members of this group will loose thier rights?"}
//           </span>
//         </div>
//         <div
//           className="messagebox-insider2"
//           style={{
//             display: "flex",
//             gap: "10px",
//             marginTop: "10px",
//             justifyContent: "flex-end",
//           }}
//         >
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={async () => {
//               setIsMessageBoxVisible(false);
//               await handleToggleActiveConfirmed(activate);
//             }}
//           >
//             YES
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//             }}
//           >
//             NO
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//     setIsMessageBoxVisible(true);
//   };

//   const handleToggleActiveConfirmed = async (activate) => {
//     if (!userGroupId) {
//       showMessage("Missing user_group_id", false);
//       return;
//     }

//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{activate ? "Activating user group..." : "Deactivating user group..."}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       setIsMessageBoxVisible(true);
//     }

//     try {
//       const userNameForApi =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name ??
//         localStorage.getItem("username") ??
//         "";
//       const token = localStorage.getItem("other");
//       if (!token) {
//         showMessage("Not authenticated (missing token)", false);
//         return;
//       }

//       // Use same API as deactivate — set status to '1' for activate, '0' for deactivate
//       const qs = new URLSearchParams({
//         user_group_id: String(userGroupId),
//         comments: comments ?? "",
//         status: activate ? "1" : "0",
//         modified_by: userNameForApi ?? "",
//       });

//       const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/deactivate-user-group?${qs.toString()}`;
//       const resp = await fetch(url, {
//         method: "PUT",
//         headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       const json = await resp.json();

//       if (json && json.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{json.message || (activate ? "User group activated successfully!" : "User group deactivated successfully!")}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setStatus(activate ? "Active" : "Inactive");
//         setTimeout(() => setIsMessageBoxVisible(false), 2000);
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {(json && json.message) || (activate ? "Failed to activate user group." : "Failed to deactivate user group.")}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Toggle active error:", err);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Error while updating user group status.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   // --- edit state + group-owner selection logic ---
//   const [editMode, setEditMode] = useState(false);

//   // employee search options used by the owner selection dropdown
//   const [employeeOptions, setEmployeeOptions] = useState([]);
//   // selectedOwnerUserId stores the employee's user_id (as required by update API)
//   const [selectedOwnerUserId, setSelectedOwnerUserId] = useState(() => {
//     const v = findValue([
//       "Group Owner User ID",
//       "GroupOwnerUserID",
//       "group_owner_user_id",
//       "n*Group Owner User ID",
//     ]);
//     // Treat NA / N/A as empty
//     return isMeaningfulId(v) ? String(v) : "";
//   });

//   // IMPORTANT CHANGE:
//   // When entering edit mode:
//   // - If we have a meaningful owner id -> keep a placeholder option for it (so edit shows current owner)
//   // - If we DON'T have a meaningful owner id (NA / N/A / empty) -> ensure dropdown is blank (no "NA / N/A" placeholder)
//   useEffect(() => {
//     if (!editMode) return;

//     if (isMeaningfulId(selectedOwnerUserId)) {
//       // keep or add placeholder for the existing owner (so user can see current owner in edit)
//       const exists = employeeOptions.some(
//         (o) => String(o.id) === String(selectedOwnerUserId)
//       );
//       if (!exists) {
//         const placeholderLabel =
//           (groupOwnerName && String(groupOwnerName).trim()) || "Current Owner";
//         const placeholder = {
//           id: selectedOwnerUserId,
//           label: `${placeholderLabel} / N/A`,
//           fullData: { emp_first_name: placeholderLabel },
//         };
//         setEmployeeOptions((prev) => {
//           const already = prev.some(
//             (p) => String(p.id) === String(selectedOwnerUserId)
//           );
//           if (already) return prev;
//           return [placeholder, ...prev];
//         });
//       }
//     } else {
//       // NO meaningful owner -> ensure dropdown is empty so user sees a blank selector
//       setEmployeeOptions([]);
//       // ensure selected id is empty string (clear any stray values)
//       setSelectedOwnerUserId("");
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [editMode, selectedOwnerUserId, groupOwnerName]);

//   // fetch employees for group owner search (maps to user_id)
//   const fetchEmployeeCoordinator = (searchKey) => {
//     if (!searchKey || String(searchKey).trim().length === 0) {
//       // Keep any meaningful selectedOwnerUserId option visible; otherwise clear list so dropdown is blank for selection.
//       if (isMeaningfulId(selectedOwnerUserId)) {
//         setEmployeeOptions((prev) =>
//           prev.filter((p) => String(p.id) === String(selectedOwnerUserId))
//         );
//       } else {
//         setEmployeeOptions([]);
//       }
//       return;
//     }

//     fetch(
//       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-employee-by-search-key/?search_key=${encodeURIComponent(
//         searchKey
//       )}`,
//       {
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${localStorage.getItem("other")}`,
//         },
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         const arr = Array.isArray(data) ? data : [];
//         const options = arr.map((emp) => ({
//           id: emp.user_id ?? emp.emp_id,
//           label: `${[emp.emp_first_name, emp.emp_middle_name, emp.emp_last_name]
//             .filter(Boolean)
//             .join(" ")} / ${emp.staff_number || "N/A"}`,
//           fullData: emp,
//         }));

//         setEmployeeOptions((prev) => {
//           // If we have a meaningful selectedOwnerUserId, keep that option at top as placeholder
//           const placeholder = prev.find(
//             (p) => String(p.id) === String(selectedOwnerUserId)
//           );
//           const merged = options.filter(
//             (o) => String(o.id) !== String(selectedOwnerUserId)
//           );
//           return placeholder ? [placeholder, ...merged] : merged;
//         });
//       })
//       .catch((err) => {
//         console.error("Error fetching employee coordinator:", err);
//         // on error, revert to showing only meaningful selectedOwnerUserId option (if any)
//         if (isMeaningfulId(selectedOwnerUserId)) {
//           setEmployeeOptions((prev) =>
//             prev.filter((p) => String(p.id) === String(selectedOwnerUserId))
//           );
//         } else {
//           setEmployeeOptions([]);
//         }
//       });
//   };

//   // Save/Update handler (update-user-group-details)
//   // Only append group_owner_user_id if non-empty (when cleared we omit param)
//   const handleSaveChanges = async () => {
//     if (isInactive()) return;
//     if (!userGroupId) {
//       showMessage("Missing user_group_id", false);
//       return;
//     }

//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Saving user group...</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       setIsMessageBoxVisible(true);
//     }

//     try {
//       const userNameForApi =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name ??
//         localStorage.getItem("username") ??
//         "";
//       const token = localStorage.getItem("other");
//       if (!token) {
//         showMessage("Not authenticated (missing token)", false);
//         return;
//       }

//       const qs = new URLSearchParams({
//         user_group_id: String(userGroupId),
//         group_desc: studentGroupDesc ?? "",
//         email_flag: emailFlag === "True" ? "1" : "0",
//         message_flag: messageFlag === "True" ? "1" : "0",
//         comments: comments ?? "",
//         user_name: userNameForApi ?? "",
//       });

//       // only append group_owner_user_id when present (omit on clear)
//       if (isMeaningfulId(selectedOwnerUserId)) {
//         qs.append("group_owner_user_id", String(selectedOwnerUserId));
//       }

//       const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-user-group-details?${qs.toString()}`;
//       const resp = await fetch(url, {
//         method: "PUT",
//         headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       const json = await resp.json();

//       if (json && json.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{json.message || "User group updated successfully."}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setTimeout(() => setIsMessageBoxVisible(false), 2000);

//         // exit edit mode and update displayed group owner name if possible
//         setEditMode(false);
//         const found = employeeOptions.find(
//           (o) => String(o.id) === String(selectedOwnerUserId)
//         );
//         if (found) {
//           const label = found.label || "";
//           const ownerName = label.split(" / ")[0] || label;
//           setGroupOwnerName(ownerName);
//         } else {
//           // If no owner selected -> show NA in read-only view
//           if (!isMeaningfulId(selectedOwnerUserId)) {
//             setGroupOwnerName("NA");
//           } else {
//             // fallback: clear
//             setGroupOwnerName("");
//           }
//         }
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {(json && json.message) || "Failed to update user group."}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Save error:", err);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Error while saving user group.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   // Table helpers
//   const handleTableRowSelectionForUserGroups = (newSelectedRows) => {
//     setSelectedUserGroups(newSelectedRows);
//   };

//   const handleDeleteRoleFromGroup = (groupName, roleNameToRemove) => {
//     setGroupedRows((prev) =>
//       prev.map((g) =>
//         g.group_name === groupName
//           ? {
//               ...g,
//               roles: g.roles.filter((r) => r.role_name !== roleNameToRemove),
//             }
//           : g
//       )
//     );
//   };

//   const reviewerGroupLabel = () => {
//     if (quesReviewerGroupId === "NA" || quesReviewerGroupId === null)
//       return "No";
//     return "Yes";
//   };

//   const sampleHeaders = ["User Groups", "Roles", "Screens", "Reports"];

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">User Group Details</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/user_groups_dashboard")}
//           >
//             CANCEL
//           </button>

//           <button
//             className="cr-create-btn"
//             onClick={onToggleActiveClicked}
//             disabled={isDefaultGroup()} // disable when default group
//             style={{ minWidth: 125, marginLeft: 8 }}
//           >
//             {/* Show ACTIVATE when inactive, DEACTIVATE when active */}
//             {isInactive() ? "ACTIVATE" : "DEACTIVATE"}
//           </button>

//           {!editMode ? (
//             <button
//               className="cr-create-btn"
//               onClick={() => !isInactive() && setEditMode(true)}
//               disabled={isDefaultGroup()} // disable EDIT when default group
//               style={{ marginLeft: 8 }}
//             >
//               EDIT
//             </button>
//           ) : (
//             <button
//               className="cr-create-btn"
//               onClick={handleSaveChanges}
//               disabled={isInactive()}
//               style={{ marginLeft: 8 }}
//             >
//               SAVE
//             </button>
//           )}
//         </div>
//       </div>

//       {/* GROUP INFORMATION */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>GROUP INFORMATION</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs
//                   label="User Group Name"
//                   type="text"
//                   required
//                   value={studentGroupName}
//                   onChange={(e) => setStudentGroupName(e.target.value)}
//                   disabled
//                 />
//               </div>

//               <div className="item2">
//                 <FormInputs
//                   label="User Group Description"
//                   type="text"
//                   required
//                   value={studentGroupDesc}
//                   onChange={(e) => setStudentGroupDesc(e.target.value)}
//                   disabled={!editMode}
//                 />
//               </div>

//               <div className="item3">
//                 {!editMode ? (
//                   <FormInputs
//                     label="Message Enabled"
//                     value={
//                       messageFlag == "True" ||
//                       messageFlag == 1 ||
//                       messageFlag == "1"
//                         ? "True"
//                         : "False"
//                     }
//                     disabled
//                   />
//                 ) : (
//                   <DropDown
//                     label="Message Enabled"
//                     options={[
//                       { id: 1, label: "True" },
//                       { id: 0, label: "False" },
//                     ]}
//                     selected={messageFlag === "True" ? 1 : 0}
//                     setSelected={(val) =>
//                       setMessageFlag(val === 1 ? "True" : "False")
//                     }
//                     disabled={!editMode}
//                     placeholder=""
//                   />
//                 )}
//               </div>

//               <div className="item4">
//                 {!editMode ? (
//                   <FormInputs
//                     label="Email Enabled"
//                     value={
//                       emailFlag == "True" || emailFlag == 1 || emailFlag == "1"
//                         ? "True"
//                         : "False"
//                     }
//                     disabled
//                   />
//                 ) : (
//                   <DropDown
//                     label="Email Enabled"
//                     options={[
//                       { id: 1, label: "True" },
//                       { id: 0, label: "False" },
//                     ]}
//                     selected={emailFlag === "True" ? 1 : 0}
//                     setSelected={(val) => setEmailFlag(val === 1 ? "True" : "False")}
//                     disabled={!editMode}
//                     placeholder=""
//                   />
//                 )}
//               </div>

//               <div className="item5">
//                 <FormInputs
//                   label="Created By"
//                   type="text"
//                   value={createdBy}
//                   disabled
//                 />
//               </div>

//               <div className="item6">
//                 {!editMode ? (
//                   <FormInputs
//                     label="Group Owner Name"
//                     value={groupOwnerName || ""}
//                     disabled
//                   />
//                 ) : (
//                   <SingleSelectSearchDropdown
//                     label="Group Owner Name"
//                     width="100%"
//                     singleSelect={true}
//                     selected={selectedOwnerUserId}
//                     setSelected={(val) => {
//                       setSelectedOwnerUserId(
//                         val === null || val === undefined || val === "" ? "" : String(val)
//                       );
//                     }}
//                     options={employeeOptions}
//                     placeholder="Search and Select Group Owner Name..."
//                     onSearchInputChange={fetchEmployeeCoordinator}
//                     isRequired={false}
//                   />
//                 )}
//               </div>

//               <div className="item7" style={{ gridColumn: "1 / 2" }}>
//                 <FormInputs
//                   label="Last Modified Date"
//                   type="text"
//                   value={lastModifiedDate}
//                   disabled
//                 />
//               </div>

//               <div className="item8" style={{ gridColumn: "2 / 3" }}>
//                 <FormInputs
//                   label="Default Group"
//                   value={defaultUserGroup}
//                   disabled
//                 />
//               </div>

//               <div className="item9" style={{ gridColumn: "3 / 4" }}>
//                 <FormInputs label="Status" value={status} disabled />
//               </div>

//               <div className="item10" style={{ gridColumn: "1 / -1" }}>
//                 <FormInputs
//                   label="Comments"
//                   type="text"
//                   value={comments}
//                   onChange={(e) => setComments(e.target.value)}
//                   disabled={!editMode}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* QUESTION REVIEWER GROUP */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>QUESTION REVIEWER GROUP</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs
//                   label="Is this a Question Reviewer Group?"
//                   type="text"
//                   value={reviewerGroupLabel()}
//                   disabled
//                 />
//               </div>

//               <div className="item2">
//                 <FormInputs
//                   label="Course"
//                   type="text"
//                   value={courseNameField == "NA" ? "" : courseNameField}
//                   disabled
//                 />
//               </div>

//               <div className="item3">
//                 <FormInputs
//                   label="Subject"
//                   type="text"
//                   value={subjectNameField == "NA" ? "" : subjectNameField}
//                   disabled
//                 />
//               </div>

//               <div className="item4">
//                 <FormInputs
//                   label="HOD or Faculty Reviewer Group?"
//                   type="text"
//                   value={reviewerGroupType == "NA" ? "" : reviewerGroupType}
//                   disabled
//                 />
//               </div>

//               <div className="item5">
//                 <FormInputs
//                   label="Reviewer Level"
//                   type="text"
//                   value={
//                     facultyReviewLevel == "NA" || facultyReviewLevel == "0"
//                       ? ""
//                       : String(facultyReviewLevel)
//                   }
//                   disabled
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ACCESS INFO table */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ACCESS INFO</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="user-groups-table-container">
//             {Array.isArray(groupedRows) && groupedRows.length > 0 ? (
//               <TableForAccessView
//                 headers={sampleHeaders}
//                 data={groupedRows}
//                 searchPlaceholder="Search access..."
//                 selectedRows={selectedUserGroups}
//                 setSelectedRows={handleTableRowSelectionForUserGroups}
//                 renderQuestionText={(text) => (text ? text : "")}
//                 renderQuestionTextModel={(text) => (text ? text : "")}
//                 expandedStates={{}}
//                 toggleImage={() => {}}
//                 questionDetailsMap={{}}
//                 handleEyeClick={() => {}}
//                 pageType="userGroups"
//                 onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                 filterConfig={{}}
//                 handleDeleteRow={(payload) => {
//                   handleDeleteRoleFromGroup(payload.groupName, payload.roleName);
//                 }}
//               />
//             ) : (
//               <div
//                 style={{
//                   textAlign: "center",
//                   color: "#9b9b9b",
//                   padding: "40px 0",
//                   fontStyle: "italic",
//                 }}
//               >
//                 No screens available
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UserGroupDetails;
























import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import DropDown from "./DropdownPrevValue";
import SingleSelectSearchDropdown from "../../StudentGrouph/SingleSelectSearchDropdown";
import TableForAccessView from "../../../Components/TableComponent/TableForAccessView";
import SuccessImg from ".././../../Assets/Images/CommanImages/Informative.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
import { API_BASE_URL } from "../../../Config/Config";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import { fetchSessionData } from "../../../Redux/Sessions/sessionSlice";
import "./updatedusergroup.css";
import EndPoints from "../../../Api/Endpoints";

// Helper: consider NA / N/A (case-insensitive) as empty/no-value
// const isMeaningfulId = (v) => {
//   if (v === null || v === undefined) return false;
//   const s = String(v).trim();
//   if (s === "") return false;
//   const up = s.toUpperCase();
//   if (up === "NA" || up === "N/A") return false;
//   return true;
// };
// return true if value is meaningful (not empty and not NA/N/A)
const isMeaningfulId = (v) => {
  if (v === null || v === undefined) return false;
  const s = String(v).trim();
  if (s === "") return false;
  const up = s.toUpperCase();
  if (up === "NA" || up === "N/A" || up === "---") return false;
  return true;
};

// strip any trailing " / ..." suffix used in labels, and trim
const stripLabelName = (label) => {
  if (!label && label !== 0) return "";
  const s = String(label);
  // split on " / " and return the first part trimmed
  return s.split(" / ")[0].trim();
};


function UserGroupDetails({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const passedHeaders = location.state?.headers ?? [];
  const passedRow = location.state?.rowData ?? [];
  const query = new URLSearchParams(location.search || "");

  const headerIndexOf = (name) => {
    if (!Array.isArray(passedHeaders)) return -1;
    const exact = passedHeaders.findIndex((h) => String(h).trim() === name);
    if (exact !== -1) return exact;
    const strippedIndex = passedHeaders.findIndex(
      (h) =>
        String(h)
          .replace(/^[a-z]\*/, "")
          .trim() === name
    );
    if (strippedIndex !== -1) return strippedIndex;
    const ci = passedHeaders.findIndex(
      (h) =>
        String(h)
          .replace(/^[a-z]\*/, "")
          .trim()
          .toLowerCase() === name.toLowerCase()
    );
    return ci;
  };

  const getValueFromPassed = (name) => {
    if (!Array.isArray(passedRow) || passedRow.length === 0) return "";
    const idx = headerIndexOf(name);
    if (idx === -1) return "";
    const v = passedRow[idx];
    return v === null || v === undefined ? "" : v;
  };

  const findValue = (names) => {
    for (const n of names) {
      const v = getValueFromPassed(n);
      if (v !== "") return v;
      const q = query.get(n) ?? query.get(n.replace(/\s+/g, ""));
      if (q) return q;
    }
    return "";
  };

  // === Validation regex for description (typing: allow spaces, trim on save) ===
  const groupDescAllowedRegex = /^[A-Za-z0-9\s\-\_.,'"\(\)\?!:;@#\$%&\*\+=\[\]\{\}<>\/\\`~]*$/;

  // --- initial states (read once or via effect below) ---
  const [userGroupId] = useState(() =>
    findValue(["User Group ID", "UserGroupId", "UserGroupID"])
  );
  const [studentGroupName, setStudentGroupName] = useState(() =>
    findValue(["User Group Name", "UserGroupName", "t*User Group Name"])
  );
  const [studentGroupDesc, setStudentGroupDesc] = useState(() =>
    findValue([
      "User Group Description",
      "UserGroupDescription",
      "t*User Group Description",
    ])
  );

  // flags
  const initialMessageFlag = (() => {
    const v = findValue(["Message Flag", "MessageFlag", "t*Message Flag"]);
    if (v === "" || v === null) return 0;
    return Number(v) === 1 ? 1 : 0;
  })();
  const initialEmailFlag = (() => {
    const v = findValue(["Email Flag", "EmailFlag", "t*Email Flag"]);
    if (v === "" || v === null) return 0;
    return Number(v) === 1 ? 1 : 0;
  })();

  const [messageFlag, setMessageFlag] = useState(initialMessageFlag);
  const [emailFlag, setEmailFlag] = useState(initialEmailFlag);

  const [comments, setComments] = useState(() =>
    findValue(["Comments", "t*Comments"])
  );
  const [status, setStatus] = useState(() => {
    const v = findValue(["Status", "t*Status"]);
    if (String(v) === "0") return "Inactive";
    return v || "";
  });
  const [lastModifiedDate, setLastModifiedDate] = useState(() =>
    findValue([
      "Last Modified Date",
      "LastModifiedDate",
      "d*Last Modified Date",
    ])
  );
  const [createdBy, setCreatedBy] = useState(() =>
    findValue(["Created By", "CreatedBy", "t*Created By"])
  );
  const [groupOwnerName, setGroupOwnerName] = useState(() =>
    findValue(["Group Owner Name", "GroupOwnerName", "t*Group Owner Name"])
  );
  const [defaultUserGroup, setDefaultUserGroup] = useState(() =>
    findValue(["Default Group", "DefaultUserGroup", "t*Default Group"])
  );

  // reviewer group fields
  const [quesReviewerGroupId, setQuesReviewerGroupId] = useState(() =>
    findValue([
      "Ques Reviewer Group ID",
      "QuesReviewerGroupID",
      "n*Ques Reviewer Group ID",
    ])
  );
  const [courseIdField, setCourseIdField] = useState(() =>
    findValue(["Course ID", "CourseID", "n*Course ID"])
  );
  const [courseNameField, setCourseNameField] = useState(() =>
    findValue(["Course Name", "CourseName", "t*Course Name"])
  );
  const [subjectIdField, setSubjectIdField] = useState(() =>
    findValue(["Subject ID", "SubjectID", "n*Subject ID"])
  );
  const [subjectNameField, setSubjectNameField] = useState(() =>
    findValue(["Subject Name", "SubjectName", "t*Subject Name"])
  );
  const [reviewerGroupType, setReviewerGroupType] = useState(() =>
    findValue([
      "Reviewer Group Type",
      "ReviewerGroupType",
      "t*Reviewer Group Type",
    ])
  );
  const [facultyReviewLevel, setFacultyReviewLevel] = useState(() =>
    findValue([
      "Faculty Review Level",
      "FacultyReviewLevel",
      "n*Faculty Review Level",
    ])
  );

  // access table
  const [groupedRows, setGroupedRows] = useState([]);
  const [selectedUserGroups, setSelectedUserGroups] = useState([]);
  const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);

  // edit state + validation state for description
  const [editMode, setEditMode] = useState(false);
  const [groupDescValid, setGroupDescValid] = useState(true);

  // fetch courses/sessions
  useEffect(() => {
    dispatch(fetchCourseData());
    dispatch(fetchSessionData());
  }, [dispatch]);

  // Mirror incoming props/state into local state
  useEffect(() => {
    setStudentGroupName(
      findValue(["User Group Name", "UserGroupName", "t*User Group Name"])
    );
    setStudentGroupDesc(
      findValue([
        "User Group Description",
        "UserGroupDescription",
        "t*User Group Description",
      ])
    );

    setMessageFlag(
      (() => {
        const v = findValue(["Message Flag", "MessageFlag", "t*Message Flag"]);
        return v == "True" ? "True" : "False";
      })()
    );
    setEmailFlag(
      (() => {
        const v = findValue(["Email Flag", "EmailFlag", "t*Email Flag"]);
        return v == "True" ? "True" : "False";
      })()
    );

    setComments(findValue(["Comments", "t*Comments"]));
    setStatus(
      (() => {
        const v = findValue(["Status", "t*Status"]);
        return String(v) === "0" ? "Inactive" : v || "";
      })()
    );
    setLastModifiedDate(
      findValue([
        "Last Modified Date",
        "LastModifiedDate",
        "d*Last Modified Date",
      ])
    );
    setCreatedBy(findValue(["Created By", "CreatedBy", "t*Created By"]));
    // setGroupOwnerName(
    //   findValue(["Group Owner Name", "GroupOwnerName", "t*Group Owner Name"])
    // );
    setGroupOwnerName(stripLabelName(findValue(["Group Owner Name", "GroupOwnerName", "t*Group Owner Name"])));

    setDefaultUserGroup(
      findValue(["Default Group", "DefaultUserGroup", "t*Default Group"])
    );
    setQuesReviewerGroupId(
      findValue([
        "Ques Reviewer Group ID",
        "QuesReviewerGroupID",
        "n*Ques Reviewer Group ID",
      ])
    );
    setCourseIdField(findValue(["Course ID", "CourseID", "n*Course ID"]));
    setCourseNameField(
      findValue(["Course Name", "CourseName", "t*Course Name"])
    );
    setSubjectIdField(findValue(["Subject ID", "SubjectID", "n*Subject ID"]));
    setSubjectNameField(
      findValue(["Subject Name", "SubjectName", "t*Subject Name"])
    );
    setReviewerGroupType(
      findValue([
        "Reviewer Group Type",
        "ReviewerGroupType",
        "t*Reviewer Group Type",
      ])
    );
    setFacultyReviewLevel(
      findValue([
        "Faculty Review Level",
        "FacultyReviewLevel",
        "n*Faculty Review Level",
      ])
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  // When entering edit mode, convert placeholder comments (NA / --- etc) into an empty string
useEffect(() => {
  if (editMode) {
    const rawComments = findValue(["Comments", "t*Comments"]);
    // if not meaningful (NA/N/A/--- etc) set empty so user sees a blank input
    if (!isMeaningfulId(rawComments)) {
      setComments("");
    } else {
      // keep the meaningful comment for editing
      setComments(rawComments);
    }

    // Also ensure owner dropdown placeholder label is only name (if we already created it above).
    if (isMeaningfulId(selectedOwnerUserId)) {
      setEmployeeOptions((prev) => {
        const placeholder = prev.find((p) => String(p.id) === String(selectedOwnerUserId));
        if (placeholder) {
          // sanitize placeholder label
          const sanitized = { ...placeholder, label: stripLabelName(placeholder.label) };
          return [sanitized, ...prev.filter((p) => String(p.id) !== String(selectedOwnerUserId))];
        }
        return prev;
      });
    }
  } else {
    // when exiting edit mode, restore displayed comments from source (keep whatever originally came in)
    setComments(findValue(["Comments", "t*Comments"]));
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [editMode]);


  const showMessage = (text, success = true) => {
    if (setMessageBox) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{text}</span>
          </div>
        </div>
      );
      setActiveImg(success ? SuccessImg : ErrorImg);
      setIsMessageBoxVisible(true);
      setTimeout(() => setIsMessageBoxVisible(false), 2500);
    } else {
      console.log("MSG:", text);
    }
  };

  const isInactive = () => {
    const s = String(status || "").toLowerCase();
    return s === "inactive" || s === "0";
  };

  // default group check: treat "True", "true", 1, "1" as true
  const isDefaultGroup = () => {
    const v = defaultUserGroup;
    return (
      v === true ||
      v === "True" ||
      v === "true" ||
      v === 1 ||
      v === "1" ||
      String(v).toLowerCase() === "true"
    );
  };

  // fetch roles/screens/reports for this user group from API
  useEffect(() => {
    async function fetchRolesForGroup() {
      if (!userGroupId) {
        setGroupedRows([]);
        return;
      }

      try {
        const token = localStorage.getItem("other");
        const qs = new URLSearchParams({ user_group_id: String(userGroupId) });
        const url = `${EndPoints.PRISM_GET_USER_GROUP_ROLE_SCREEN_REPORT_ACCESS_DETAILS_BY_USER_ID}?${qs.toString()}`;

        const res = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });

        const json = await res.json();

        if (
          res.ok &&
          json &&
          json.status === 200 &&
          Array.isArray(json.data) &&
          json.data.length > 0
        ) {
          setGroupedRows(json.data);
        } else {
          setGroupedRows([]);
        }
      } catch (err) {
        console.error("Failed to fetch roles for group:", err);
        setGroupedRows([]);
        showMessage("Error fetching roles for user group", false);
      }
    }

    fetchRolesForGroup();
  }, [userGroupId]);

  // Deactivate/Activate flow - single handler
  const onToggleActiveClicked = () => {
    if (isDefaultGroup()) return;
    if (isInactive()) {
      confirmToggleActive(true);
    } else {
      confirmToggleActive(false);
    }
  };

  const confirmToggleActive = (activate) => {
    if (!setMessageBox) {
      const confirmMsg = activate
        ? "Are you sure you want to activate this user group?"
        : "Are you sure you want to deactivate this user group, members of this group will loose thier rights?";
      if (window.confirm(confirmMsg)) {
        handleToggleActiveConfirmed(activate);
      }
      return;
    }

    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>
            {activate
              ? "Are you sure you want to activate this user group?"
              : "Are you sure you want to deactivate this user group, members of this group will loose thier rights?"}
          </span>
        </div>
        <div
          className="messagebox-insider2"
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
            justifyContent: "flex-end",
          }}
        >
          <button
            className="messagebox-cancel-btn-ok"
            onClick={async () => {
              setIsMessageBoxVisible(false);
              await handleToggleActiveConfirmed(activate);
            }}
          >
            YES
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
            }}
          >
            NO
          </button>
        </div>
      </div>
    );
    setActiveImg(InterogativeImg);
    setIsMessageBoxVisible(true);
  };

  const handleToggleActiveConfirmed = async (activate) => {
    if (!userGroupId) {
      showMessage("Missing user_group_id", false);
      return;
    }

    if (setMessageBox) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{activate ? "Activating user group..." : "Deactivating user group..."}</span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      setIsMessageBoxVisible(true);
    }

    try {
      const userNameForApi =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name ??
        localStorage.getItem("username") ??
        "";
      const token = localStorage.getItem("other");
      if (!token) {
        showMessage("Not authenticated (missing token)", false);
        return;
      }

      const qs = new URLSearchParams({
        user_group_id: String(userGroupId),
        comments: comments ?? "",
        status: activate ? "1" : "0",
        modified_by: userNameForApi ?? "",
      });

      const url = `${EndPoints.PRISM_DEACTIVATE_USER_GROUP}?${qs.toString()}`;
      const resp = await fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const json = await resp.json();

      if (json && json.status === 200) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{json.message || (activate ? "User group activated successfully!" : "User group deactivated successfully!")}</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setIsMessageBoxVisible(true);
        setStatus(activate ? "Active" : "Inactive");
        setTimeout(() => setIsMessageBoxVisible(false), 2000);
      } else {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {(json && json.message) || (activate ? "Failed to activate user group." : "Failed to deactivate user group.")}
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
      }
    } catch (err) {
      console.error("Toggle active error:", err);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Error while updating user group status.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
    }
  };

  // --- edit state + group-owner selection logic ---
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedOwnerUserId, setSelectedOwnerUserId] = useState(() => {
    const v = findValue([
      "Group Owner User ID",
      "GroupOwnerUserID",
      "group_owner_user_id",
      "n*Group Owner User ID",
    ]);
    return isMeaningfulId(v) ? String(v) : "";
  });

  // When entering edit mode: keep placeholder if meaningful owner id exists, else clear options
  useEffect(() => {
    if (!editMode) return;

    // if (isMeaningfulId(selectedOwnerUserId)) {
    //   const exists = employeeOptions.some(
    //     (o) => String(o.id) === String(selectedOwnerUserId)
    //   );
    //   if (!exists) {
    //     const placeholderLabel =
    //       (groupOwnerName && String(groupOwnerName).trim()) || "Current Owner";
    //     const placeholder = {
    //       id: selectedOwnerUserId,
    //       label: `${placeholderLabel} / N/A`,
    //       fullData: { emp_first_name: placeholderLabel, user_id: selectedOwnerUserId },
    //     };
    //     setEmployeeOptions((prev) => {
    //       const already = prev.some(
    //         (p) => String(p.id) === String(selectedOwnerUserId)
    //       );
    //       if (already) return prev;
    //       return [placeholder, ...prev];
    //     });
    //   }
    // } else {
    //   setEmployeeOptions([]);
    //   setSelectedOwnerUserId("");
    // }
    if (isMeaningfulId(selectedOwnerUserId)) {
      const exists = employeeOptions.some((o) => String(o.id) === String(selectedOwnerUserId));
      if (!exists) {
        // show *only* the name as placeholder label (no " / N/A" suffix)
        const placeholderLabel = stripLabelName(groupOwnerName) || "Current Owner";
        const placeholder = {
          id: selectedOwnerUserId,
          label: placeholderLabel,
          fullData: { emp_first_name: placeholderLabel, user_id: selectedOwnerUserId },
        };
        setEmployeeOptions((prev) => {
          const already = prev.some((p) => String(p.id) === String(selectedOwnerUserId));
          if (already) return prev;
          return [placeholder, ...prev];
        });
      }
    } else {
      setEmployeeOptions([]);
      setSelectedOwnerUserId("");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editMode, selectedOwnerUserId, groupOwnerName]);

  // fetch employees for group owner search (use same behaviour as UpdatedCreateUserGroup)
  // Only include employees with a user_id (app user) and use user_id as id.
  const fetchEmployeeCoordinator = (searchKey) => {
    if (!searchKey || String(searchKey).trim().length === 0) {
      // Keep placeholder if meaningful selectedOwnerUserId exists; otherwise clear
      if (isMeaningfulId(selectedOwnerUserId)) {
        setEmployeeOptions((prev) =>
          prev.filter((p) => String(p.id) === String(selectedOwnerUserId))
        );
      } else {
        setEmployeeOptions([]);
      }
      return;
    }

    fetch(
      `${EndPoints.PRISM_GET_EMPLOYEE_BY_SEARCH_KEY}?search_key=${encodeURIComponent(
        searchKey
      )}`,
      {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("other")}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const arr = Array.isArray(data) ? data : [];
        // Filter to only those with user_id (app user) — same rule as UpdatedCreateUserGroup
        const filtered = arr.filter((emp) => emp && (emp.user_id !== null && emp.user_id !== undefined));
        const options = filtered.map((emp) => ({
          id: emp.user_id, // use user_id as id
          label: `${[emp.emp_first_name, emp.emp_middle_name, emp.emp_last_name]
            .filter(Boolean)
            .join(" ")} / ${emp.staff_number || "N/A"} / ${emp.department || "N/A"}`,
          fullData: emp,
        }));

        setEmployeeOptions((prev) => {
          // If we have a meaningful selectedOwnerUserId, keep that option at top as placeholder
          const placeholder = prev.find(
            (p) => String(p.id) === String(selectedOwnerUserId)
          );
          const merged = options.filter(
            (o) => String(o.id) !== String(selectedOwnerUserId)
          );
          return placeholder ? [placeholder, ...merged] : merged;
        });
      })
      .catch((err) => {
        console.error("Error fetching employee coordinator:", err);
        if (isMeaningfulId(selectedOwnerUserId)) {
          setEmployeeOptions((prev) =>
            prev.filter((p) => String(p.id) === String(selectedOwnerUserId))
          );
        } else {
          setEmployeeOptions([]);
        }
      });
  };

  // Save/Update handler (update-user-group-details)
  const handleSaveChanges = async () => {
    if (isInactive()) return;
    if (!userGroupId) {
      showMessage("Missing user_group_id", false);
      return;
    }

    if (setMessageBox) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Saving user group...</span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      setIsMessageBoxVisible(true);
    }

    try {
      const userNameForApi =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name ??
        localStorage.getItem("username") ??
        "";
      const token = localStorage.getItem("other");
      if (!token) {
        showMessage("Not authenticated (missing token)", false);
        return;
      }

      // trim description now (allow internal spaces)
      const finalDesc = (studentGroupDesc || "").trim();

      // You can remove the empty-check below if empty description is allowed by your API.
      if (finalDesc === "") {
        setGroupDescValid(false);
        showMessage("User Group Description cannot be empty.", false);
        setIsMessageBoxVisible(false);
        return;
      }

      if (finalDesc.length > 500) {
        setGroupDescValid(false);
        showMessage("Description must be at most 500 characters.", false);
        setIsMessageBoxVisible(false);
        return;
      }

      if (!groupDescAllowedRegex.test(finalDesc)) {
        setGroupDescValid(false);
        showMessage("Description contains invalid characters.", false);
        setIsMessageBoxVisible(false);
        return;
      }

      setGroupDescValid(true);

      const qs = new URLSearchParams({
        user_group_id: String(userGroupId),
        group_desc: finalDesc,
        email_flag: emailFlag === "True" ? "1" : "0",
        message_flag: messageFlag === "True" ? "1" : "0",
        comments: comments ?? "",
        user_name: userNameForApi ?? "",
      });

      // only append group_owner_user_id when present
      if (isMeaningfulId(selectedOwnerUserId)) {
        qs.append("group_owner_user_id", String(selectedOwnerUserId));
      }

      const url = `${EndPoints.PRISM_UPDATE_USER_GROUP_DETAILS}?${qs.toString()}`;
      const resp = await fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const json = await resp.json();

      if (json && json.status === 200) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{json.message || "User group updated successfully."}</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setIsMessageBoxVisible(true);
        setTimeout(() => setIsMessageBoxVisible(false), 2000);

        // exit edit mode and update displayed group owner name if possible
        setEditMode(false);
        const found = employeeOptions.find(
          (o) => String(o.id) === String(selectedOwnerUserId)
        );
        if (found) {
          const label = found.label || "";
          const ownerName = label.split(" / ")[0] || label;
          setGroupOwnerName(ownerName);
        } else {
          if (!isMeaningfulId(selectedOwnerUserId)) {
            setGroupOwnerName("NA");
          } else {
            setGroupOwnerName("");
          }
        }

        // update local description to trimmed value
        setStudentGroupDesc(finalDesc);
      } else {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {(json && json.message) || "Failed to update user group."}
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
      }
    } catch (err) {
      console.error("Save error:", err);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Error while saving user group.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
    }
  };

  // Table helpers
  const handleTableRowSelectionForUserGroups = (newSelectedRows) => {
    setSelectedUserGroups(newSelectedRows);
  };

  const handleDeleteRoleFromGroup = (groupName, roleNameToRemove) => {
    setGroupedRows((prev) =>
      prev.map((g) =>
        g.group_name === groupName
          ? {
              ...g,
              roles: g.roles.filter((r) => r.role_name !== roleNameToRemove),
            }
          : g
      )
    );
  };

  const reviewerGroupLabel = () => {
    if (quesReviewerGroupId === "NA" || quesReviewerGroupId === null)
      return "No";
    return "Yes";
  };

  const sampleHeaders = ["User Groups", "Roles", "Screens", "Reports"];

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">User Group Details</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => navigate("/user_groups_dashboard")}
          >
            CANCEL
          </button>

          <button
            className="cr-create-btn"
            onClick={onToggleActiveClicked}
            disabled={isDefaultGroup()}
            style={{ minWidth: 125, marginLeft: 8 }}
          >
            {isInactive() ? "ACTIVATE" : "DEACTIVATE"}
          </button>

          {!editMode ? (
            <button
              className="cr-create-btn"
              onClick={() => !isInactive() && setEditMode(true)}
              disabled={isDefaultGroup() || isInactive()}
              style={{
                marginLeft: 8,
                opacity: isDefaultGroup() || isInactive() ? 0.45 : 1,
                cursor: isDefaultGroup() || isInactive() ? "not-allowed" : "pointer",
              }}
            >
              EDIT
            </button>
          ) : (
            <button
              className="cr-create-btn"
              onClick={handleSaveChanges}
              disabled={isInactive()}
              style={{ marginLeft: 8 }}
            >
              SAVE
            </button>
          )}
        </div>
      </div>

      {/* GROUP INFORMATION */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>GROUP INFORMATION</label>
          </div>
        </div>

        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div className="item1">
                <FormInputs
                  label="User Group Name"
                  type="text"
                  // required
                  value={studentGroupName}
                  onChange={(e) => setStudentGroupName(e.target.value)}
                  disabled
                />
              </div>

              <div className="item2">
                <FormInputs
                  label="User Group Description"
                  type="text"
                  // required
                  value={studentGroupDesc}
                  onChange={(e) => {
                    // while typing: DO NOT trim; allow internal spaces
                    let val = e.target.value || "";
                    if (val.length > 500) val = val.slice(0, 500);
                    setStudentGroupDesc(val);
                    const allowed = groupDescAllowedRegex.test(val);
                    const isValid = allowed && val.length <= 500;
                    setGroupDescValid(isValid);
                  }}
                  disabled={!editMode}
                  className={!groupDescValid ? "input-error" : ""}
                  inputClassName={!groupDescValid ? "input-error" : ""}
                  style={!groupDescValid ? { border: "1px solid red" } : {}}
                />
              </div>

              <div className="item3">
                {!editMode ? (
                  <FormInputs
                    label="Message Enabled"
                    value={
                      messageFlag == "True" ||
                      messageFlag == 1 ||
                      messageFlag == "1"
                        ? "True"
                        : "False"
                    }
                    disabled
                  />
                ) : (
                  <DropDown
                    label="Message Enabled"
                    options={[
                      { id: 1, label: "True" },
                      { id: 0, label: "False" },
                    ]}
                    selected={messageFlag === "True" ? 1 : 0}
                    setSelected={(val) =>
                      setMessageFlag(val === 1 ? "True" : "False")
                    }
                    disabled={!editMode}
                    placeholder=""
                  />
                )}
              </div>

              <div className="item4">
                {!editMode ? (
                  <FormInputs
                    label="Email Enabled"
                    value={
                      emailFlag == "True" || emailFlag == 1 || emailFlag == "1"
                        ? "True"
                        : "False"
                    }
                    disabled
                  />
                ) : (
                  <DropDown
                    label="Email Enabled"
                    options={[
                      { id: 1, label: "True" },
                      { id: 0, label: "False" },
                    ]}
                    selected={emailFlag === "True" ? 1 : 0}
                    setSelected={(val) => setEmailFlag(val === 1 ? "True" : "False")}
                    disabled={!editMode}
                    placeholder=""
                  />
                )}
              </div>

              <div className="item5">
                <FormInputs
                  label="Created By"
                  type="text"
                  value={createdBy}
                  disabled
                />
              </div>

              <div className="item6">
                {!editMode ? (
                  <FormInputs
                    label="Group Owner Name"
                    value={groupOwnerName || ""}
                    disabled
                  />
                ) : (
                  <SingleSelectSearchDropdown
                    label="Group Owner Name"
                    width="100%"
                    singleSelect={true}
                    selected={selectedOwnerUserId}
                    setSelected={(val) => {
                      setSelectedOwnerUserId(
                        val === null || val === undefined || val === "" ? "" : String(val)
                      );
                    }}
                    options={employeeOptions}
                    placeholder="Search and Select Group Owner Name..."
                    onSearchInputChange={fetchEmployeeCoordinator}
                    isRequired={false}
                  />
                )}
              </div>

              <div className="item7" style={{ gridColumn: "1 / 2" }}>
                <FormInputs
                  label="Last Modified Date"
                  type="text"
                  value={lastModifiedDate}
                  disabled
                />
              </div>

              <div className="item8" style={{ gridColumn: "2 / 3" }}>
                <FormInputs
                  label="Default Group"
                  value={defaultUserGroup}
                  disabled
                />
              </div>

              <div className="item9" style={{ gridColumn: "3 / 4" }}>
                <FormInputs label="Status" value={status} disabled />
              </div>

              <div className="item10" style={{ gridColumn: "1 / -1" }}>
                <FormInputs
                  label="Comments"
                  type="text"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                  disabled={!editMode}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* QUESTION REVIEWER GROUP */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>QUESTION REVIEWER GROUP</label>
          </div>
        </div>

        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div className="item1">
                <FormInputs
                  label="Is this a Question Reviewer Group?"
                  type="text"
                  value={reviewerGroupLabel()}
                  disabled
                />
              </div>

              <div className="item2">
                <FormInputs
                  label="Course"
                  type="text"
                  value={courseNameField == "NA" ? "-NA-" : courseNameField}
                  disabled
                />
              </div>

              <div className="item3">
                <FormInputs
                  label="Subject"
                  type="text"
                  value={subjectNameField == "NA" ? "-NA-" : subjectNameField}
                  disabled
                />
              </div>

              <div className="item4">
                <FormInputs
                  label="HOD or Faculty Reviewer Group?"
                  type="text"
                  value={reviewerGroupType == "NA" ? "-NA-" : reviewerGroupType}
                  disabled
                />
              </div>

              <div className="item5">
                <FormInputs
                  label="Reviewer Level"
                  type="text"
                  value={
                    facultyReviewLevel == "NA" || facultyReviewLevel == "0"
                      ? "-NA-"
                      : String(facultyReviewLevel)
                  }
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ACCESS INFO table */}
      <div className="ques-paper-del" style={{ marginTop: "20px" }}>
        <div className="personal-header">
          <div className="header">
            <label>ACCESS INFO</label>
          </div>
        </div>

        <div className="accordion-content">
          <div className="user-groups-table-container">
            {Array.isArray(groupedRows) && groupedRows.length > 0 ? (
              <TableForAccessView
                headers={sampleHeaders}
                data={groupedRows}
                searchPlaceholder="Search access..."
                selectedRows={selectedUserGroups}
                setSelectedRows={handleTableRowSelectionForUserGroups}
                renderQuestionText={(text) => (text ? text : "")}
                renderQuestionTextModel={(text) => (text ? text : "")}
                expandedStates={{}}
                toggleImage={() => {}}
                questionDetailsMap={{}}
                handleEyeClick={() => {}}
                pageType="userGroups"
                onRowLinkClick={(row) => console.log("Row clicked:", row)}
                filterConfig={{}}
                handleDeleteRow={(payload) => {
                  handleDeleteRoleFromGroup(payload.groupName, payload.roleName);
                }}
              />
            ) : (
              <div
                style={{
                  textAlign: "center",
                  color: "#9b9b9b",
                  padding: "40px 0",
                  fontStyle: "italic",
                }}
              >
                No screens available
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserGroupDetails;


